// СГЕНЕРИРОВАНО генератором миссий (developer_artifacts/scripts/missionGen).
// Правится не руками, а перегенерацией: npx tsx developer_artifacts/scripts/missionGen/generate_humans_5.cjs
/* eslint-disable */
const mission = {
  "id": "humans_5",
  "campaignFactionId": "humans",
  "order": 5,
  "title": "Пепел на востоке",
  "shortTitle": "Миссия V",
  "description": "Обоз отстал: на пять отрядов — четыре фермы. Достраивай хлеб в первом же раунде, веди эшелоны вверх по серпантину — и посмотри в лицо тем, кто бежит",
  "finalRound": 12,
  "reward": {
    "type": "faction",
    "factionId": "orcs"
  },
  "rewardIfFactionOwned": {
    "type": "chest",
    "chestId": "chest_random_epic"
  },
  "playerColor": "blue",
  "players": [
    {
      "name": "Луций",
      "color": "blue",
      "factionId": "humans",
      "selectedSkin": "humans_default",
      "isBot": false,
      "bonus": "none"
    },
    {
      "name": "Чёрный Зуб",
      "color": "red",
      "factionId": "orcs",
      "selectedSkin": "orcs_default",
      "isBot": true,
      "bonus": "none"
    },
    {
      "name": "Мор-Гхаа",
      "color": "light_green",
      "factionId": "orcs",
      "selectedSkin": "orcs_default",
      "isBot": true,
      "bonus": "none"
    }
  ],
  "field": {
    "hexes": {
      "-6,-2": "mountain",
      "-6,-1": "mountain",
      "-6,0": "mountain",
      "-5,-3": "mountain",
      "-5,-2": "mountain",
      "-5,-1": "mountain",
      "-5,0": "mountain",
      "-4,-4": "mountain",
      "-4,-3": "mountain",
      "-4,-2": "mountain",
      "-4,-1": "mountain",
      "-4,0": "mountain",
      "-3,-4": "mountain",
      "-3,-3": "mountain",
      "-3,-2": "mountain",
      "-3,-1": "mountain",
      "-2,-4": "mountain",
      "-2,-3": "mountain",
      "-2,-2": "mountain",
      "-2,-5": "mountain",
      "-1,-6": "mountain",
      "-1,-5": "mountain",
      "-1,-4": "mountain",
      "-1,-3": "mountain",
      "-1,-2": "mountain",
      "0,-6": "mountain",
      "0,-5": "mountain",
      "0,-4": "mountain",
      "0,-3": "mountain",
      "1,-6": "mountain",
      "1,-5": "mountain",
      "1,-4": "mountain",
      "2,-7": "mountain",
      "2,-6": "mountain",
      "2,-5": "mountain",
      "2,-4": "mountain",
      "3,-8": "mountain",
      "3,-7": "mountain",
      "3,-6": "mountain",
      "3,-5": "mountain",
      "3,-4": "mountain",
      "4,-8": "mountain",
      "4,-7": "mountain",
      "4,-6": "mountain",
      "4,-5": "mountain",
      "5,-8": "mountain",
      "5,-7": "mountain",
      "5,-6": "mountain",
      "6,-9": "mountain",
      "6,-8": "mountain",
      "6,-7": "mountain",
      "7,-10": "mountain",
      "7,-9": "mountain",
      "7,-8": "mountain",
      "7,-7": "mountain",
      "7,-6": "road",
      "8,-10": "mountain",
      "8,-9": "mountain",
      "8,-8": "mountain",
      "9,-10": "mountain",
      "9,-9": "mountain",
      "9,-8": "farm",
      "-4,3": "mountain",
      "-4,4": "mountain",
      "-4,5": "mountain",
      "-3,2": "ruins",
      "-3,3": "mountain",
      "-3,4": "mountain",
      "-3,5": "mountain",
      "-2,1": "road",
      "-2,2": "mountain",
      "-2,3": "mountain",
      "-2,4": "mountain",
      "-2,5": "mountain",
      "-1,1": "mountain",
      "-1,2": "mountain",
      "-1,3": "mountain",
      "-1,4": "mountain",
      "0,1": "mountain",
      "0,2": "mountain",
      "0,3": "mountain",
      "1,0": "mountain",
      "1,1": "mountain",
      "1,2": "mountain",
      "1,3": "mountain",
      "2,-1": "mountain",
      "2,0": "mountain",
      "2,1": "mountain",
      "2,2": "mountain",
      "2,3": "mountain",
      "3,-1": "mountain",
      "3,0": "mountain",
      "3,1": "mountain",
      "3,2": "mountain",
      "4,-1": "mountain",
      "4,0": "mountain",
      "4,1": "mountain",
      "5,-2": "mountain",
      "5,-1": "mountain",
      "5,0": "mountain",
      "5,1": "mountain",
      "6,-3": "flag_light_green",
      "6,-2": "farm",
      "6,-1": "mountain",
      "6,0": "mountain",
      "6,1": "mountain",
      "7,-3": "mountain",
      "7,-2": "mountain",
      "7,-1": "mountain",
      "7,0": "mountain",
      "8,-3": "mountain",
      "8,-2": "mountain",
      "8,-1": "mountain",
      "7,-4": "quarter",
      "8,-5": "mountain",
      "8,-4": "mountain",
      "9,-6": "road",
      "9,-5": "mountain",
      "9,-4": "mountain",
      "9,-3": "mountain",
      "9,-2": "mountain",
      "10,-6": "mountain",
      "10,-5": "mountain",
      "10,-4": "mountain",
      "10,-3": "mountain",
      "11,-6": "mountain",
      "11,-5": "mountain",
      "11,-4": "mountain",
      "-6,3": "quarter",
      "-5,3": "road",
      "-4,2": "road",
      "-1,0": "road",
      "0,-1": "ruins",
      "1,-2": "road",
      "2,-3": "mine",
      "3,-3": "road",
      "4,-4": "road",
      "5,-4": "road",
      "6,-5": "road",
      "8,-6": "road",
      "4,-3": "road",
      "-7,4": "flag_blue",
      "-8,5": "quarter",
      "-7,5": "quarter",
      "-8,4": "farm",
      "-6,4": "farm",
      "-7,6": "farm",
      "-5,2": "farm",
      "-7,3": "barracks",
      "10,-8": "flag_red",
      "9,-7": "quarter",
      "11,-9": "quarter",
      "10,-9": "farm",
      "11,-8": "farm",
      "10,-7": "farm",
      "7,-5": "mountain",
      "5,-3": "farm",
      "6,-4": "farm",
      "-14,0": "mountain",
      "-14,2": "mountain",
      "-14,4": "mountain",
      "-14,6": "mountain",
      "-14,8": "mountain",
      "-14,10": "mountain",
      "-14,12": "mountain",
      "-14,14": "mountain",
      "-13,14": "mountain",
      "-12,14": "mountain",
      "-11,14": "mountain",
      "-10,14": "mountain",
      "-9,14": "mountain",
      "-8,14": "mountain",
      "-7,14": "mountain",
      "-6,14": "mountain",
      "-5,14": "mountain",
      "-4,14": "mountain",
      "-3,14": "mountain",
      "-2,14": "mountain",
      "-1,14": "mountain",
      "0,14": "mountain",
      "1,13": "mountain",
      "2,12": "mountain",
      "3,11": "mountain",
      "4,10": "mountain",
      "5,9": "mountain",
      "6,8": "mountain",
      "7,7": "mountain",
      "8,6": "mountain",
      "9,5": "mountain",
      "10,4": "mountain",
      "11,3": "mountain",
      "12,2": "mountain",
      "13,1": "mountain",
      "14,-13": "mountain",
      "14,-11": "mountain",
      "14,-9": "mountain",
      "14,-7": "mountain",
      "14,-5": "mountain",
      "14,-3": "mountain",
      "14,-1": "mountain",
      "-16,0": "mountain",
      "-16,1": "mountain",
      "-16,2": "mountain",
      "-16,3": "mountain",
      "-16,4": "mountain",
      "-16,5": "mountain",
      "-16,6": "mountain",
      "-16,7": "mountain",
      "-16,8": "mountain",
      "-16,9": "mountain",
      "-16,10": "mountain",
      "-16,11": "mountain",
      "-16,12": "mountain",
      "-16,13": "mountain",
      "-16,14": "mountain",
      "-16,15": "mountain",
      "-16,16": "mountain",
      "-15,-1": "mountain",
      "-15,16": "mountain",
      "-14,-2": "mountain",
      "-14,16": "mountain",
      "-13,-3": "mountain",
      "-13,16": "mountain",
      "-12,-4": "mountain",
      "-12,16": "mountain",
      "-11,-5": "mountain",
      "-11,16": "mountain",
      "-10,-6": "mountain",
      "-10,16": "mountain",
      "-9,-7": "mountain",
      "-9,16": "mountain",
      "-8,-8": "mountain",
      "-8,16": "mountain",
      "-7,-9": "mountain",
      "-7,16": "mountain",
      "-6,-10": "mountain",
      "-6,16": "mountain",
      "-5,-11": "mountain",
      "-5,16": "mountain",
      "-4,-12": "mountain",
      "-4,16": "mountain",
      "-3,-13": "mountain",
      "-3,16": "mountain",
      "-2,-14": "mountain",
      "-2,16": "mountain",
      "-1,-15": "mountain",
      "-1,16": "mountain",
      "0,-16": "mountain",
      "0,16": "mountain",
      "1,-16": "mountain",
      "1,15": "mountain",
      "2,-16": "mountain",
      "2,14": "mountain",
      "3,-16": "mountain",
      "3,13": "mountain",
      "4,-16": "mountain",
      "4,12": "mountain",
      "5,-16": "mountain",
      "5,11": "mountain",
      "6,-16": "mountain",
      "6,10": "mountain",
      "7,-16": "mountain",
      "7,9": "mountain",
      "8,-16": "mountain",
      "8,8": "mountain",
      "9,-16": "mountain",
      "9,7": "mountain",
      "10,-16": "mountain",
      "10,6": "mountain",
      "11,-16": "mountain",
      "11,5": "mountain",
      "12,-16": "mountain",
      "12,4": "mountain",
      "13,-16": "mountain",
      "13,3": "mountain",
      "14,-16": "mountain",
      "14,2": "mountain",
      "15,-16": "mountain",
      "15,1": "mountain",
      "16,-16": "mountain",
      "16,-15": "mountain",
      "16,-14": "mountain",
      "16,-13": "mountain",
      "16,-12": "mountain",
      "16,-11": "mountain",
      "16,-10": "mountain",
      "16,-9": "mountain",
      "16,-8": "mountain",
      "16,-7": "mountain",
      "16,-6": "mountain",
      "16,-5": "mountain",
      "16,-4": "mountain",
      "16,-3": "mountain",
      "16,-2": "mountain",
      "16,-1": "mountain",
      "16,0": "mountain"
    },
    "units": [
      {
        "id": "u_blue_0_-6_3",
        "hexKey": "-6,3",
        "ownerId": "player_id_blue",
        "type": "unit_d10",
        "size": 8,
        "maxSize": 10
      },
      {
        "id": "u_blue_1_-7_3",
        "hexKey": "-7,3",
        "ownerId": "player_id_blue",
        "type": "unit_d6",
        "size": 6,
        "maxSize": 6
      },
      {
        "id": "u_blue_2_-8_5",
        "hexKey": "-8,5",
        "ownerId": "player_id_blue",
        "type": "unit_d6",
        "size": 6,
        "maxSize": 6
      },
      {
        "id": "u_blue_3_-7_5",
        "hexKey": "-7,5",
        "ownerId": "player_id_blue",
        "type": "unit_d8",
        "size": 4,
        "maxSize": 8
      },
      {
        "id": "u_blue_4_-6_4",
        "hexKey": "-6,4",
        "ownerId": "player_id_blue",
        "type": "unit_d10",
        "size": 6,
        "maxSize": 10
      },
      {
        "id": "u_red_5_-1_0",
        "hexKey": "-1,0",
        "ownerId": "player_id_red",
        "type": "unit_d6",
        "size": 6,
        "maxSize": 6
      },
      {
        "id": "u_red_6_2_-3",
        "hexKey": "2,-3",
        "ownerId": "player_id_red",
        "type": "unit_d10",
        "size": 8,
        "maxSize": 10
      },
      {
        "id": "u_red_7_4_-4",
        "hexKey": "4,-4",
        "ownerId": "player_id_red",
        "type": "unit_d10",
        "size": 9,
        "maxSize": 10
      },
      {
        "id": "u_red_8_9_-7",
        "hexKey": "9,-7",
        "ownerId": "player_id_red",
        "type": "unit_d12",
        "size": 10,
        "maxSize": 12
      },
      {
        "id": "u_light_green_9_6_-3",
        "hexKey": "6,-3",
        "ownerId": "player_id_light_green",
        "type": "unit_d4",
        "size": 4,
        "maxSize": 4
      },
      {
        "id": "u_light_green_10_7_-4",
        "hexKey": "7,-4",
        "ownerId": "player_id_light_green",
        "type": "unit_d4",
        "size": 4,
        "maxSize": 4
      }
    ],
    "specialBuildings": {},
    "gridConfig": {
      "radius": 20,
      "hexSize": 60,
      "orientation": "flat"
    }
  },
  "policyMarket": [
    {
      "id": "fortificationism",
      "name": "Фортификационизм",
      "description": "Мгновенное строительство и скидка для крепостей\nБонус к урону рядом с крепостью",
      "implemented": true,
      "color": "#865333"
    },
    {
      "id": "ecoanarchism",
      "name": "Экоанархизм",
      "description": "Пустые ячейки не ограничивают перемещение\nПередача снабжения в любую ячейку поля",
      "implemented": true,
      "color": "#D68A5A"
    },
    {
      "id": "theocracy",
      "name": "Теократия",
      "description": "Увеличенный доход храмов\nБонус к урону отрядов в городе с храмом",
      "implemented": true,
      "color": "#A9A9A9"
    },
    {
      "id": "fanaticism",
      "name": "Фанатизм",
      "description": "Увеличенный доход руин\nБонус к урону отрядов смежно с руинами\nОбмен очков на монеты",
      "implemented": true,
      "color": "#A9A9A9"
    },
    {
      "id": "agrarianism",
      "name": "Аграризм",
      "description": "Скидка на Ферму и Склад\nОбмен снабжения на монеты",
      "implemented": true,
      "color": "#D68A5A"
    },
    {
      "id": "isolationism",
      "name": "Изоляционизм",
      "description": "Защита права первого хода\nСкидка на особые строения\nБонус к урону отрядов в своих городах",
      "implemented": true,
      "color": "#b09292"
    }
  ],
  "script": [
    {
      "id": "e_0_replica",
      "moment": {
        "round": 0,
        "phase": "setup",
        "stage": null,
        "playerColor": "blue"
      },
      "kind": "replica",
      "replica": {
        "text": "«Пощада — роскошь победителей, Луций, и как всякую роскошь её надо уметь себе позволить. Щади, когда пощада работает на Рим: щажёный галл платит подати, мёртвый — нет. Но никогда не щади из жалости: жалость — это когда ты покупаешь себе облегчение за чужой счёт, и в этой сделке Рим…»",
        "characterName": "Из писем отца",
        "side": "left",
        "characterImage": "/img/campaigns/humans/letters_marc.png"
      }
    },
    {
      "id": "e_1_replica",
      "moment": {
        "round": 0,
        "phase": "setup",
        "stage": null,
        "playerColor": "blue"
      },
      "kind": "replica",
      "replica": {
        "text": "…Дальше я помню наизусть. Раньше помогало. Выступаем.",
        "characterName": "Луций",
        "side": "left",
        "characterImage": "/img/campaigns/humans/m5_lucius_doubt.png"
      }
    },
    {
      "id": "e_2_objective",
      "moment": {
        "round": 0,
        "phase": "setup",
        "stage": null,
        "playerColor": "blue"
      },
      "kind": "objective",
      "objective": {
        "id": "h5_break_blackteeth",
        "type": "destroy_all_enemy_units",
        "params": {
          "color": "red"
        },
        "text": "Пробей заслоны Чёрного Зуба и добей ватагу",
        "isMain": true,
        "isFailure": false
      }
    },
    {
      "id": "e_3_objective",
      "moment": {
        "round": 0,
        "phase": "setup",
        "stage": null,
        "playerColor": "blue"
      },
      "kind": "objective",
      "objective": {
        "id": "h5_saddle",
        "type": "unit_reaches_hex",
        "params": {
          "hexKey": "8,-6"
        },
        "text": "Выведи отряд на седловину и удерживай её (кормить её будет ферма передового лагеря — но только когда тропа очищена от ватаги; или захваченные фермы гнезда)",
        "isMain": true,
        "isFailure": false
      }
    },
    {
      "id": "e_4_objective",
      "moment": {
        "round": 0,
        "phase": "setup",
        "stage": null,
        "playerColor": "blue"
      },
      "kind": "objective",
      "objective": {
        "id": "h5_shaman",
        "type": "survive_rounds",
        "params": {
          "rounds": 12
        },
        "text": "Дослушай Старую Кость — продержись до 12-го раунда",
        "isMain": true,
        "isFailure": false
      }
    },
    {
      "id": "e_5_objective",
      "moment": {
        "round": 0,
        "phase": "setup",
        "stage": null,
        "playerColor": "blue"
      },
      "kind": "objective",
      "objective": {
        "id": "h5_ruins_watch",
        "type": "unit_reaches_hex",
        "params": {
          "hexKey": "-3,2"
        },
        "text": "Займи руины Норика дозором",
        "isMain": false,
        "isFailure": false
      }
    },
    {
      "id": "e_6_objective",
      "moment": {
        "round": 0,
        "phase": "setup",
        "stage": null,
        "playerColor": "blue"
      },
      "kind": "objective",
      "objective": {
        "id": "h5_forward_camp",
        "type": "build_central_quarter",
        "params": {
          "hexKey": "1,-1"
        },
        "text": "Заложи передовой лагерь у второго мёртвого городка — выше руин корпус не прокормить",
        "isMain": false,
        "isFailure": false
      }
    },
    {
      "id": "e_7_objective",
      "moment": {
        "round": 0,
        "phase": "setup",
        "stage": null,
        "playerColor": "blue"
      },
      "kind": "objective",
      "objective": {
        "id": "h5_keep_corps",
        "type": "units_count",
        "params": {
          "amount": 4
        },
        "text": "Сбереги корпус — обоз отстал, хлеб дают только фермы",
        "isMain": false,
        "isFailure": false
      }
    },
    {
      "id": "e_8_objective",
      "moment": {
        "round": 0,
        "phase": "setup",
        "stage": null,
        "playerColor": "blue"
      },
      "kind": "objective",
      "objective": {
        "id": "h5_corps_lost",
        "type": "lose_all_units",
        "params": {},
        "text": "Корпус не должен погибнуть",
        "isMain": false,
        "isFailure": true
      }
    },
    {
      "id": "entry_9_SET_STARTING_QUARTER",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 0,
        "phase": "setup",
        "stage": null,
        "playerColor": "red"
      },
      "action": {
        "type": "SET_STARTING_QUARTER",
        "payload": {
          "playerId": "player_id_red",
          "hexKey": "10,-8"
        }
      }
    },
    {
      "id": "entry_10_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 0,
        "phase": "setup",
        "stage": null,
        "playerColor": "red"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 0,
          "currentPlayerId": "player_id_red",
          "phase": "setup",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_11_SET_STARTING_QUARTER",
      "kind": "action",
      "playerColor": "light_green",
      "moment": {
        "round": 0,
        "phase": "setup",
        "stage": null,
        "playerColor": "light_green"
      },
      "action": {
        "type": "SET_STARTING_QUARTER",
        "payload": {
          "playerId": "player_id_light_green",
          "hexKey": "6,-3"
        }
      }
    },
    {
      "id": "entry_12_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "light_green",
      "moment": {
        "round": 0,
        "phase": "setup",
        "stage": null,
        "playerColor": "light_green"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 0,
          "currentPlayerId": "player_id_light_green",
          "phase": "setup",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_13_START_NEXT_PHASE",
      "kind": "action",
      "playerColor": "light_green",
      "moment": {
        "round": 0,
        "phase": "setup",
        "stage": null,
        "playerColor": "light_green"
      },
      "action": {
        "type": "START_NEXT_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "newPolicy": {
            "id": "totalitarianism",
            "name": "Тоталитаризм",
            "description": "Очки за военные строения\nСкидка на Лагерь и Арсенал\nНайм отрядов увеличенного размера",
            "implemented": true,
            "color": "#98172d"
          },
          "round": 0,
          "currentPlayerId": "player_id_light_green",
          "phase": "setup",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_14_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 1,
        "phase": "supply",
        "stage": null,
        "playerColor": "red"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "9,-8",
          "unitId": "u_red_5_-1_0",
          "unitHexKey": "-1,0",
          "isAutoSupply": true,
          "isNotUndoable": false
        }
      }
    },
    {
      "id": "entry_15_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 1,
        "phase": "supply",
        "stage": null,
        "playerColor": "red"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "10,-9",
          "unitId": "u_red_6_2_-3",
          "unitHexKey": "2,-3",
          "isAutoSupply": true,
          "isNotUndoable": false
        }
      }
    },
    {
      "id": "entry_16_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 1,
        "phase": "supply",
        "stage": null,
        "playerColor": "red"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "11,-8",
          "unitId": "u_red_7_4_-4",
          "unitHexKey": "4,-4",
          "isAutoSupply": true,
          "isNotUndoable": false
        }
      }
    },
    {
      "id": "entry_17_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 1,
        "phase": "supply",
        "stage": null,
        "playerColor": "red"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "10,-7",
          "unitId": "u_red_8_9_-7",
          "unitHexKey": "9,-7",
          "isAutoSupply": true,
          "isNotUndoable": false
        }
      }
    },
    {
      "id": "entry_18_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 1,
        "phase": "supply",
        "stage": null,
        "playerColor": "red"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 1,
          "currentPlayerId": "player_id_red",
          "phase": "supply",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_19_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "light_green",
      "moment": {
        "round": 1,
        "phase": "supply",
        "stage": null,
        "playerColor": "light_green"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "6,-4",
          "unitId": "u_light_green_10_7_-4",
          "unitHexKey": "7,-4",
          "isAutoSupply": true,
          "isNotUndoable": false
        }
      }
    },
    {
      "id": "entry_20_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "light_green",
      "moment": {
        "round": 1,
        "phase": "supply",
        "stage": null,
        "playerColor": "light_green"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "5,-3",
          "unitId": "u_light_green_9_6_-3",
          "unitHexKey": "6,-3",
          "isAutoSupply": true,
          "isNotUndoable": false
        }
      }
    },
    {
      "id": "entry_21_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "light_green",
      "moment": {
        "round": 1,
        "phase": "supply",
        "stage": null,
        "playerColor": "light_green"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "6,-2",
          "unitId": "u_light_green_9_6_-3",
          "unitHexKey": "6,-3",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_22_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "light_green",
      "moment": {
        "round": 1,
        "phase": "supply",
        "stage": null,
        "playerColor": "light_green"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 1,
          "currentPlayerId": "player_id_light_green",
          "phase": "supply",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_23_START_NEXT_PHASE",
      "kind": "action",
      "playerColor": "light_green",
      "moment": {
        "round": 1,
        "phase": "supply",
        "stage": null,
        "playerColor": "light_green"
      },
      "action": {
        "type": "START_NEXT_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "newPolicy": {
            "id": "oligarchy",
            "name": "Олигархия",
            "description": "2 гильдий в одном городе\nУвеличенный доход гильдий",
            "implemented": true,
            "color": "#DEA806"
          },
          "round": 1,
          "currentPlayerId": "player_id_light_green",
          "phase": "supply",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_24_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 1,
        "phase": "construction",
        "stage": null,
        "playerColor": "red"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 1,
          "currentPlayerId": "player_id_red",
          "phase": "construction",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_25_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "light_green",
      "moment": {
        "round": 1,
        "phase": "construction",
        "stage": null,
        "playerColor": "light_green"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 1,
          "currentPlayerId": "player_id_light_green",
          "phase": "construction",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_26_START_NEXT_PHASE",
      "kind": "action",
      "playerColor": "light_green",
      "moment": {
        "round": 1,
        "phase": "construction",
        "stage": null,
        "playerColor": "light_green"
      },
      "action": {
        "type": "START_NEXT_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "newPolicy": {
            "id": "theocracy",
            "name": "Теократия",
            "description": "Увеличенный доход храмов\nБонус к урону отрядов в городе с храмом",
            "implemented": true,
            "color": "#A9A9A9"
          },
          "round": 1,
          "currentPlayerId": "player_id_light_green",
          "phase": "construction",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_27_APPLY_RECRUITMENT_ACTIONS",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 1,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "red"
      },
      "action": {
        "type": "APPLY_RECRUITMENT_ACTIONS",
        "payload": {}
      }
    },
    {
      "id": "entry_28_SET_WAR_PHASE_STAGE",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 1,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "red"
      },
      "action": {
        "type": "SET_WAR_PHASE_STAGE",
        "payload": {
          "stage": "movement",
          "timestamp": 1700000000000,
          "round": 1,
          "currentPlayerId": "player_id_red",
          "phase": "war",
          "warPhaseStage": "recruitment"
        }
      }
    },
    {
      "id": "entry_29_APPLY_MOVEMENT_ACTIONS",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 1,
        "phase": "war",
        "stage": "movement",
        "playerColor": "red"
      },
      "action": {
        "type": "APPLY_MOVEMENT_ACTIONS",
        "payload": {}
      }
    },
    {
      "id": "entry_30_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 1,
        "phase": "war",
        "stage": "movement",
        "playerColor": "red"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 1,
          "currentPlayerId": "player_id_red",
          "phase": "war",
          "warPhaseStage": "movement"
        }
      }
    },
    {
      "id": "entry_31_APPLY_RECRUITMENT_ACTIONS",
      "kind": "action",
      "playerColor": "light_green",
      "moment": {
        "round": 1,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "light_green"
      },
      "action": {
        "type": "APPLY_RECRUITMENT_ACTIONS",
        "payload": {}
      }
    },
    {
      "id": "entry_32_SET_WAR_PHASE_STAGE",
      "kind": "action",
      "playerColor": "light_green",
      "moment": {
        "round": 1,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "light_green"
      },
      "action": {
        "type": "SET_WAR_PHASE_STAGE",
        "payload": {
          "stage": "movement",
          "timestamp": 1700000000000,
          "round": 1,
          "currentPlayerId": "player_id_light_green",
          "phase": "war",
          "warPhaseStage": "recruitment"
        }
      }
    },
    {
      "id": "entry_33_APPLY_MOVEMENT_ACTIONS",
      "kind": "action",
      "playerColor": "light_green",
      "moment": {
        "round": 1,
        "phase": "war",
        "stage": "movement",
        "playerColor": "light_green"
      },
      "action": {
        "type": "APPLY_MOVEMENT_ACTIONS",
        "payload": {}
      }
    },
    {
      "id": "entry_34_SET_WAR_PHASE_STAGE",
      "kind": "action",
      "playerColor": "light_green",
      "moment": {
        "round": 1,
        "phase": "war",
        "stage": "movement",
        "playerColor": "light_green"
      },
      "action": {
        "type": "SET_WAR_PHASE_STAGE",
        "payload": {
          "stage": "shooting",
          "timestamp": 1700000000000,
          "round": 1,
          "currentPlayerId": "player_id_light_green",
          "phase": "war",
          "warPhaseStage": "movement"
        }
      }
    },
    {
      "id": "entry_35_APPLY_SHOOTING_ACTIONS",
      "kind": "action",
      "playerColor": "light_green",
      "moment": {
        "round": 1,
        "phase": "war",
        "stage": "shooting",
        "playerColor": "light_green"
      },
      "action": {
        "type": "APPLY_SHOOTING_ACTIONS",
        "payload": {}
      }
    },
    {
      "id": "entry_36_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "light_green",
      "moment": {
        "round": 1,
        "phase": "war",
        "stage": "shooting",
        "playerColor": "light_green"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 1,
          "currentPlayerId": "player_id_light_green",
          "phase": "war",
          "warPhaseStage": "shooting"
        }
      }
    },
    {
      "id": "entry_37_CAPTURE_CITIES",
      "kind": "action",
      "playerColor": "light_green",
      "moment": {
        "round": 1,
        "phase": "war",
        "stage": "shooting",
        "playerColor": "light_green"
      },
      "action": {
        "type": "CAPTURE_CITIES",
        "payload": {
          "round": 1,
          "phase": "war"
        }
      }
    },
    {
      "id": "entry_38_START_NEXT_PHASE",
      "kind": "action",
      "playerColor": "light_green",
      "moment": {
        "round": 1,
        "phase": "war",
        "stage": "shooting",
        "playerColor": "light_green"
      },
      "action": {
        "type": "START_NEXT_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "newPolicy": {
            "id": "ecoanarchism",
            "name": "Экоанархизм",
            "description": "Пустые ячейки не ограничивают перемещение\nПередача снабжения в любую ячейку поля",
            "implemented": true,
            "color": "#D68A5A"
          },
          "round": 1,
          "currentPlayerId": "player_id_light_green",
          "phase": "war",
          "warPhaseStage": "shooting"
        }
      }
    },
    {
      "id": "entry_39_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 2,
        "phase": "supply",
        "stage": null,
        "playerColor": "red"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "9,-8",
          "unitId": "u_red_5_-1_0",
          "unitHexKey": "-1,0",
          "isAutoSupply": true,
          "isNotUndoable": false
        }
      }
    },
    {
      "id": "entry_40_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 2,
        "phase": "supply",
        "stage": null,
        "playerColor": "red"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "10,-9",
          "unitId": "u_red_6_2_-3",
          "unitHexKey": "2,-3",
          "isAutoSupply": true,
          "isNotUndoable": false
        }
      }
    },
    {
      "id": "entry_41_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 2,
        "phase": "supply",
        "stage": null,
        "playerColor": "red"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "11,-8",
          "unitId": "u_red_7_4_-4",
          "unitHexKey": "4,-4",
          "isAutoSupply": true,
          "isNotUndoable": false
        }
      }
    },
    {
      "id": "entry_42_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 2,
        "phase": "supply",
        "stage": null,
        "playerColor": "red"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "10,-7",
          "unitId": "u_red_8_9_-7",
          "unitHexKey": "9,-7",
          "isAutoSupply": true,
          "isNotUndoable": false
        }
      }
    },
    {
      "id": "entry_43_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 2,
        "phase": "supply",
        "stage": null,
        "playerColor": "red"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 2,
          "currentPlayerId": "player_id_red",
          "phase": "supply",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_44_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "light_green",
      "moment": {
        "round": 2,
        "phase": "supply",
        "stage": null,
        "playerColor": "light_green"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "6,-4",
          "unitId": "u_light_green_10_7_-4",
          "unitHexKey": "7,-4",
          "isAutoSupply": true,
          "isNotUndoable": false
        }
      }
    },
    {
      "id": "entry_45_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "light_green",
      "moment": {
        "round": 2,
        "phase": "supply",
        "stage": null,
        "playerColor": "light_green"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "5,-3",
          "unitId": "u_light_green_9_6_-3",
          "unitHexKey": "6,-3",
          "isAutoSupply": true,
          "isNotUndoable": false
        }
      }
    },
    {
      "id": "entry_46_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "light_green",
      "moment": {
        "round": 2,
        "phase": "supply",
        "stage": null,
        "playerColor": "light_green"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "6,-2",
          "unitId": "u_light_green_9_6_-3",
          "unitHexKey": "6,-3",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_47_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "light_green",
      "moment": {
        "round": 2,
        "phase": "supply",
        "stage": null,
        "playerColor": "light_green"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 2,
          "currentPlayerId": "player_id_light_green",
          "phase": "supply",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_48_START_NEXT_PHASE",
      "kind": "action",
      "playerColor": "light_green",
      "moment": {
        "round": 2,
        "phase": "supply",
        "stage": null,
        "playerColor": "light_green"
      },
      "action": {
        "type": "START_NEXT_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "newPolicy": {
            "id": "theocracy",
            "name": "Теократия",
            "description": "Увеличенный доход храмов\nБонус к урону отрядов в городе с храмом",
            "implemented": true,
            "color": "#A9A9A9"
          },
          "round": 2,
          "currentPlayerId": "player_id_light_green",
          "phase": "supply",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_49_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 2,
        "phase": "construction",
        "stage": null,
        "playerColor": "red"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 2,
          "currentPlayerId": "player_id_red",
          "phase": "construction",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_50_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "light_green",
      "moment": {
        "round": 2,
        "phase": "construction",
        "stage": null,
        "playerColor": "light_green"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 2,
          "currentPlayerId": "player_id_light_green",
          "phase": "construction",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_51_START_NEXT_PHASE",
      "kind": "action",
      "playerColor": "light_green",
      "moment": {
        "round": 2,
        "phase": "construction",
        "stage": null,
        "playerColor": "light_green"
      },
      "action": {
        "type": "START_NEXT_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "newPolicy": {
            "id": "militarism",
            "name": "Милитаризм",
            "description": "Увеличенный урон в ближнем бою",
            "implemented": true,
            "color": "#98172d"
          },
          "round": 2,
          "currentPlayerId": "player_id_light_green",
          "phase": "construction",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "e_52_replica",
      "moment": {
        "round": 2,
        "phase": "war",
        "stage": "movement",
        "playerColor": "blue"
      },
      "kind": "replica",
      "replica": {
        "text": "Ни одного тела, легат. Очаги в золе, стан с недотканным холстом… Дверь вон — лопатой снаружи подпёрта. Лопатой, легат. Кто-то думал вернуться и козу с огорода шугануть.",
        "characterName": "Атилий",
        "side": "left",
        "characterImage": "/img/campaigns/humans/m5_atilius_calm.png"
      }
    },
    {
      "id": "e_53_replica",
      "moment": {
        "round": 2,
        "phase": "war",
        "stage": "movement",
        "playerColor": "blue"
      },
      "kind": "replica",
      "replica": {
        "text": "У нас так же было. Всегда кажется — на неделю уходим. Никто никогда не уходит на неделю.",
        "characterName": "Ильва",
        "side": "right",
        "characterImage": "/img/campaigns/humans/m5_ilva_grief.png"
      }
    },
    {
      "id": "e_54_replica",
      "moment": {
        "round": 2,
        "phase": "war",
        "stage": "movement",
        "playerColor": "blue"
      },
      "kind": "replica",
      "replica": {
        "text": "Норик просил у Рима помощи два года назад. Сенат «рассматривал сведения». Вот они, рассмотренные сведения. Целое царство рассмотренных сведений.",
        "characterName": "Барба",
        "side": "left",
        "characterImage": "/img/campaigns/humans/m5_barba_grim.png"
      }
    },
    {
      "id": "entry_55_APPLY_RECRUITMENT_ACTIONS",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 2,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "red"
      },
      "action": {
        "type": "APPLY_RECRUITMENT_ACTIONS",
        "payload": {}
      }
    },
    {
      "id": "entry_56_SET_WAR_PHASE_STAGE",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 2,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "red"
      },
      "action": {
        "type": "SET_WAR_PHASE_STAGE",
        "payload": {
          "stage": "movement",
          "timestamp": 1700000000000,
          "round": 2,
          "currentPlayerId": "player_id_red",
          "phase": "war",
          "warPhaseStage": "recruitment"
        }
      }
    },
    {
      "id": "entry_57_MOVE_UNIT",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 2,
        "phase": "war",
        "stage": "movement",
        "playerColor": "red"
      },
      "action": {
        "type": "MOVE_UNIT",
        "payload": {
          "unitId": "u_red_5_-1_0",
          "unitType": "unit_d6",
          "newHexKey": "-2,1"
        }
      }
    },
    {
      "id": "entry_58_ADD_PENDING_MOVEMENT_ACTION",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 2,
        "phase": "war",
        "stage": "movement",
        "playerColor": "red"
      },
      "action": {
        "type": "ADD_PENDING_MOVEMENT_ACTION",
        "payload": {
          "unitId": "u_red_5_-1_0",
          "fromHexKey": "-1,0",
          "toHexKey": "-2,1",
          "additionalSupply": false
        }
      }
    },
    {
      "id": "entry_59_APPLY_MOVEMENT_ACTIONS",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 2,
        "phase": "war",
        "stage": "movement",
        "playerColor": "red"
      },
      "action": {
        "type": "APPLY_MOVEMENT_ACTIONS",
        "payload": {}
      }
    },
    {
      "id": "entry_60_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 2,
        "phase": "war",
        "stage": "movement",
        "playerColor": "red"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 2,
          "currentPlayerId": "player_id_red",
          "phase": "war",
          "warPhaseStage": "movement"
        }
      }
    },
    {
      "id": "entry_61_APPLY_RECRUITMENT_ACTIONS",
      "kind": "action",
      "playerColor": "light_green",
      "moment": {
        "round": 2,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "light_green"
      },
      "action": {
        "type": "APPLY_RECRUITMENT_ACTIONS",
        "payload": {}
      }
    },
    {
      "id": "entry_62_SET_WAR_PHASE_STAGE",
      "kind": "action",
      "playerColor": "light_green",
      "moment": {
        "round": 2,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "light_green"
      },
      "action": {
        "type": "SET_WAR_PHASE_STAGE",
        "payload": {
          "stage": "movement",
          "timestamp": 1700000000000,
          "round": 2,
          "currentPlayerId": "player_id_light_green",
          "phase": "war",
          "warPhaseStage": "recruitment"
        }
      }
    },
    {
      "id": "entry_63_APPLY_MOVEMENT_ACTIONS",
      "kind": "action",
      "playerColor": "light_green",
      "moment": {
        "round": 2,
        "phase": "war",
        "stage": "movement",
        "playerColor": "light_green"
      },
      "action": {
        "type": "APPLY_MOVEMENT_ACTIONS",
        "payload": {}
      }
    },
    {
      "id": "entry_64_SET_WAR_PHASE_STAGE",
      "kind": "action",
      "playerColor": "light_green",
      "moment": {
        "round": 2,
        "phase": "war",
        "stage": "movement",
        "playerColor": "light_green"
      },
      "action": {
        "type": "SET_WAR_PHASE_STAGE",
        "payload": {
          "stage": "shooting",
          "timestamp": 1700000000000,
          "round": 2,
          "currentPlayerId": "player_id_light_green",
          "phase": "war",
          "warPhaseStage": "movement"
        }
      }
    },
    {
      "id": "entry_65_APPLY_SHOOTING_ACTIONS",
      "kind": "action",
      "playerColor": "light_green",
      "moment": {
        "round": 2,
        "phase": "war",
        "stage": "shooting",
        "playerColor": "light_green"
      },
      "action": {
        "type": "APPLY_SHOOTING_ACTIONS",
        "payload": {}
      }
    },
    {
      "id": "entry_66_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "light_green",
      "moment": {
        "round": 2,
        "phase": "war",
        "stage": "shooting",
        "playerColor": "light_green"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 2,
          "currentPlayerId": "player_id_light_green",
          "phase": "war",
          "warPhaseStage": "shooting"
        }
      }
    },
    {
      "id": "entry_67_CAPTURE_CITIES",
      "kind": "action",
      "playerColor": "light_green",
      "moment": {
        "round": 2,
        "phase": "war",
        "stage": "shooting",
        "playerColor": "light_green"
      },
      "action": {
        "type": "CAPTURE_CITIES",
        "payload": {
          "round": 2,
          "phase": "war"
        }
      }
    },
    {
      "id": "entry_68_START_NEXT_PHASE",
      "kind": "action",
      "playerColor": "light_green",
      "moment": {
        "round": 2,
        "phase": "war",
        "stage": "shooting",
        "playerColor": "light_green"
      },
      "action": {
        "type": "START_NEXT_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "newPolicy": {
            "id": "despotism",
            "name": "Деспотизм",
            "description": "Скидка на найм отрядов\nСкидка на постройку Лагеря",
            "implemented": true,
            "color": "#98172d"
          },
          "round": 2,
          "currentPlayerId": "player_id_light_green",
          "phase": "war",
          "warPhaseStage": "shooting"
        }
      }
    },
    {
      "id": "entry_69_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 3,
        "phase": "supply",
        "stage": null,
        "playerColor": "red"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "9,-8",
          "unitId": "u_red_5_-1_0",
          "unitHexKey": "-2,1",
          "isAutoSupply": true,
          "isNotUndoable": false
        }
      }
    },
    {
      "id": "entry_70_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 3,
        "phase": "supply",
        "stage": null,
        "playerColor": "red"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "10,-9",
          "unitId": "u_red_6_2_-3",
          "unitHexKey": "2,-3",
          "isAutoSupply": true,
          "isNotUndoable": false
        }
      }
    },
    {
      "id": "entry_71_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 3,
        "phase": "supply",
        "stage": null,
        "playerColor": "red"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "11,-8",
          "unitId": "u_red_7_4_-4",
          "unitHexKey": "4,-4",
          "isAutoSupply": true,
          "isNotUndoable": false
        }
      }
    },
    {
      "id": "entry_72_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 3,
        "phase": "supply",
        "stage": null,
        "playerColor": "red"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "10,-7",
          "unitId": "u_red_8_9_-7",
          "unitHexKey": "9,-7",
          "isAutoSupply": true,
          "isNotUndoable": false
        }
      }
    },
    {
      "id": "entry_73_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 3,
        "phase": "supply",
        "stage": null,
        "playerColor": "red"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 3,
          "currentPlayerId": "player_id_red",
          "phase": "supply",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_74_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "light_green",
      "moment": {
        "round": 3,
        "phase": "supply",
        "stage": null,
        "playerColor": "light_green"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "6,-4",
          "unitId": "u_light_green_10_7_-4",
          "unitHexKey": "7,-4",
          "isAutoSupply": true,
          "isNotUndoable": false
        }
      }
    },
    {
      "id": "entry_75_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "light_green",
      "moment": {
        "round": 3,
        "phase": "supply",
        "stage": null,
        "playerColor": "light_green"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "5,-3",
          "unitId": "u_light_green_9_6_-3",
          "unitHexKey": "6,-3",
          "isAutoSupply": true,
          "isNotUndoable": false
        }
      }
    },
    {
      "id": "entry_76_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "light_green",
      "moment": {
        "round": 3,
        "phase": "supply",
        "stage": null,
        "playerColor": "light_green"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "6,-2",
          "unitId": "u_light_green_9_6_-3",
          "unitHexKey": "6,-3",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_77_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "light_green",
      "moment": {
        "round": 3,
        "phase": "supply",
        "stage": null,
        "playerColor": "light_green"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 3,
          "currentPlayerId": "player_id_light_green",
          "phase": "supply",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_78_START_NEXT_PHASE",
      "kind": "action",
      "playerColor": "light_green",
      "moment": {
        "round": 3,
        "phase": "supply",
        "stage": null,
        "playerColor": "light_green"
      },
      "action": {
        "type": "START_NEXT_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "newPolicy": {
            "id": "despotism",
            "name": "Деспотизм",
            "description": "Скидка на найм отрядов\nСкидка на постройку Лагеря",
            "implemented": true,
            "color": "#98172d"
          },
          "round": 3,
          "currentPlayerId": "player_id_light_green",
          "phase": "supply",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_79_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 3,
        "phase": "construction",
        "stage": null,
        "playerColor": "red"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 3,
          "currentPlayerId": "player_id_red",
          "phase": "construction",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_80_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "light_green",
      "moment": {
        "round": 3,
        "phase": "construction",
        "stage": null,
        "playerColor": "light_green"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 3,
          "currentPlayerId": "player_id_light_green",
          "phase": "construction",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_81_START_NEXT_PHASE",
      "kind": "action",
      "playerColor": "light_green",
      "moment": {
        "round": 3,
        "phase": "construction",
        "stage": null,
        "playerColor": "light_green"
      },
      "action": {
        "type": "START_NEXT_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "newPolicy": {
            "id": "agrarianism",
            "name": "Аграризм",
            "description": "Скидка на Ферму и Склад\nОбмен снабжения на монеты",
            "implemented": true,
            "color": "#D68A5A"
          },
          "round": 3,
          "currentPlayerId": "player_id_light_green",
          "phase": "construction",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_82_APPLY_RECRUITMENT_ACTIONS",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 3,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "red"
      },
      "action": {
        "type": "APPLY_RECRUITMENT_ACTIONS",
        "payload": {}
      }
    },
    {
      "id": "entry_83_SET_WAR_PHASE_STAGE",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 3,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "red"
      },
      "action": {
        "type": "SET_WAR_PHASE_STAGE",
        "payload": {
          "stage": "movement",
          "timestamp": 1700000000000,
          "round": 3,
          "currentPlayerId": "player_id_red",
          "phase": "war",
          "warPhaseStage": "recruitment"
        }
      }
    },
    {
      "id": "entry_84_MOVE_UNIT",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 3,
        "phase": "war",
        "stage": "movement",
        "playerColor": "red"
      },
      "action": {
        "type": "MOVE_UNIT",
        "payload": {
          "unitId": "u_red_5_-1_0",
          "unitType": "unit_d6",
          "newHexKey": "-1,0"
        }
      }
    },
    {
      "id": "entry_85_ADD_PENDING_MOVEMENT_ACTION",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 3,
        "phase": "war",
        "stage": "movement",
        "playerColor": "red"
      },
      "action": {
        "type": "ADD_PENDING_MOVEMENT_ACTION",
        "payload": {
          "unitId": "u_red_5_-1_0",
          "fromHexKey": "-2,1",
          "toHexKey": "-1,0",
          "additionalSupply": false
        }
      }
    },
    {
      "id": "entry_86_APPLY_MOVEMENT_ACTIONS",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 3,
        "phase": "war",
        "stage": "movement",
        "playerColor": "red"
      },
      "action": {
        "type": "APPLY_MOVEMENT_ACTIONS",
        "payload": {}
      }
    },
    {
      "id": "entry_87_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 3,
        "phase": "war",
        "stage": "movement",
        "playerColor": "red"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 3,
          "currentPlayerId": "player_id_red",
          "phase": "war",
          "warPhaseStage": "movement"
        }
      }
    },
    {
      "id": "entry_88_APPLY_RECRUITMENT_ACTIONS",
      "kind": "action",
      "playerColor": "light_green",
      "moment": {
        "round": 3,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "light_green"
      },
      "action": {
        "type": "APPLY_RECRUITMENT_ACTIONS",
        "payload": {}
      }
    },
    {
      "id": "entry_89_SET_WAR_PHASE_STAGE",
      "kind": "action",
      "playerColor": "light_green",
      "moment": {
        "round": 3,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "light_green"
      },
      "action": {
        "type": "SET_WAR_PHASE_STAGE",
        "payload": {
          "stage": "movement",
          "timestamp": 1700000000000,
          "round": 3,
          "currentPlayerId": "player_id_light_green",
          "phase": "war",
          "warPhaseStage": "recruitment"
        }
      }
    },
    {
      "id": "entry_90_APPLY_MOVEMENT_ACTIONS",
      "kind": "action",
      "playerColor": "light_green",
      "moment": {
        "round": 3,
        "phase": "war",
        "stage": "movement",
        "playerColor": "light_green"
      },
      "action": {
        "type": "APPLY_MOVEMENT_ACTIONS",
        "payload": {}
      }
    },
    {
      "id": "entry_91_SET_WAR_PHASE_STAGE",
      "kind": "action",
      "playerColor": "light_green",
      "moment": {
        "round": 3,
        "phase": "war",
        "stage": "movement",
        "playerColor": "light_green"
      },
      "action": {
        "type": "SET_WAR_PHASE_STAGE",
        "payload": {
          "stage": "shooting",
          "timestamp": 1700000000000,
          "round": 3,
          "currentPlayerId": "player_id_light_green",
          "phase": "war",
          "warPhaseStage": "movement"
        }
      }
    },
    {
      "id": "entry_92_APPLY_SHOOTING_ACTIONS",
      "kind": "action",
      "playerColor": "light_green",
      "moment": {
        "round": 3,
        "phase": "war",
        "stage": "shooting",
        "playerColor": "light_green"
      },
      "action": {
        "type": "APPLY_SHOOTING_ACTIONS",
        "payload": {}
      }
    },
    {
      "id": "entry_93_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "light_green",
      "moment": {
        "round": 3,
        "phase": "war",
        "stage": "shooting",
        "playerColor": "light_green"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 3,
          "currentPlayerId": "player_id_light_green",
          "phase": "war",
          "warPhaseStage": "shooting"
        }
      }
    },
    {
      "id": "entry_94_CAPTURE_CITIES",
      "kind": "action",
      "playerColor": "light_green",
      "moment": {
        "round": 3,
        "phase": "war",
        "stage": "shooting",
        "playerColor": "light_green"
      },
      "action": {
        "type": "CAPTURE_CITIES",
        "payload": {
          "round": 3,
          "phase": "war"
        }
      }
    },
    {
      "id": "entry_95_START_NEXT_PHASE",
      "kind": "action",
      "playerColor": "light_green",
      "moment": {
        "round": 3,
        "phase": "war",
        "stage": "shooting",
        "playerColor": "light_green"
      },
      "action": {
        "type": "START_NEXT_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "newPolicy": {
            "id": "patriotism",
            "name": "Патриотизм",
            "description": "Скидка на найм размера отрядов и Арсенал",
            "implemented": true,
            "color": "#98172d"
          },
          "round": 3,
          "currentPlayerId": "player_id_light_green",
          "phase": "war",
          "warPhaseStage": "shooting"
        }
      }
    },
    {
      "id": "entry_96_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 4,
        "phase": "supply",
        "stage": null,
        "playerColor": "red"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "9,-8",
          "unitId": "u_red_5_-1_0",
          "unitHexKey": "-1,0",
          "isAutoSupply": true,
          "isNotUndoable": false
        }
      }
    },
    {
      "id": "entry_97_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 4,
        "phase": "supply",
        "stage": null,
        "playerColor": "red"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "10,-9",
          "unitId": "u_red_6_2_-3",
          "unitHexKey": "2,-3",
          "isAutoSupply": true,
          "isNotUndoable": false
        }
      }
    },
    {
      "id": "entry_98_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 4,
        "phase": "supply",
        "stage": null,
        "playerColor": "red"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "11,-8",
          "unitId": "u_red_7_4_-4",
          "unitHexKey": "4,-4",
          "isAutoSupply": true,
          "isNotUndoable": false
        }
      }
    },
    {
      "id": "entry_99_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 4,
        "phase": "supply",
        "stage": null,
        "playerColor": "red"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "10,-7",
          "unitId": "u_red_8_9_-7",
          "unitHexKey": "9,-7",
          "isAutoSupply": true,
          "isNotUndoable": false
        }
      }
    },
    {
      "id": "entry_100_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 4,
        "phase": "supply",
        "stage": null,
        "playerColor": "red"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 4,
          "currentPlayerId": "player_id_red",
          "phase": "supply",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_101_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "light_green",
      "moment": {
        "round": 4,
        "phase": "supply",
        "stage": null,
        "playerColor": "light_green"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "6,-4",
          "unitId": "u_light_green_10_7_-4",
          "unitHexKey": "7,-4",
          "isAutoSupply": true,
          "isNotUndoable": false
        }
      }
    },
    {
      "id": "entry_102_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "light_green",
      "moment": {
        "round": 4,
        "phase": "supply",
        "stage": null,
        "playerColor": "light_green"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "5,-3",
          "unitId": "u_light_green_9_6_-3",
          "unitHexKey": "6,-3",
          "isAutoSupply": true,
          "isNotUndoable": false
        }
      }
    },
    {
      "id": "entry_103_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "light_green",
      "moment": {
        "round": 4,
        "phase": "supply",
        "stage": null,
        "playerColor": "light_green"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "6,-2",
          "unitId": "u_light_green_9_6_-3",
          "unitHexKey": "6,-3",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_104_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "light_green",
      "moment": {
        "round": 4,
        "phase": "supply",
        "stage": null,
        "playerColor": "light_green"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 4,
          "currentPlayerId": "player_id_light_green",
          "phase": "supply",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_105_START_NEXT_PHASE",
      "kind": "action",
      "playerColor": "light_green",
      "moment": {
        "round": 4,
        "phase": "supply",
        "stage": null,
        "playerColor": "light_green"
      },
      "action": {
        "type": "START_NEXT_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "newPolicy": {
            "id": "patriotism",
            "name": "Патриотизм",
            "description": "Скидка на найм размера отрядов и Арсенал",
            "implemented": true,
            "color": "#98172d"
          },
          "round": 4,
          "currentPlayerId": "player_id_light_green",
          "phase": "supply",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_106_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 4,
        "phase": "construction",
        "stage": null,
        "playerColor": "red"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 4,
          "currentPlayerId": "player_id_red",
          "phase": "construction",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_107_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "light_green",
      "moment": {
        "round": 4,
        "phase": "construction",
        "stage": null,
        "playerColor": "light_green"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 4,
          "currentPlayerId": "player_id_light_green",
          "phase": "construction",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_108_START_NEXT_PHASE",
      "kind": "action",
      "playerColor": "light_green",
      "moment": {
        "round": 4,
        "phase": "construction",
        "stage": null,
        "playerColor": "light_green"
      },
      "action": {
        "type": "START_NEXT_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "newPolicy": {
            "id": "ecoanarchism",
            "name": "Экоанархизм",
            "description": "Пустые ячейки не ограничивают перемещение\nПередача снабжения в любую ячейку поля",
            "implemented": true,
            "color": "#D68A5A"
          },
          "round": 4,
          "currentPlayerId": "player_id_light_green",
          "phase": "construction",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_109_APPLY_RECRUITMENT_ACTIONS",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 4,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "red"
      },
      "action": {
        "type": "APPLY_RECRUITMENT_ACTIONS",
        "payload": {}
      }
    },
    {
      "id": "entry_110_SET_WAR_PHASE_STAGE",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 4,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "red"
      },
      "action": {
        "type": "SET_WAR_PHASE_STAGE",
        "payload": {
          "stage": "movement",
          "timestamp": 1700000000000,
          "round": 4,
          "currentPlayerId": "player_id_red",
          "phase": "war",
          "warPhaseStage": "recruitment"
        }
      }
    },
    {
      "id": "entry_111_MOVE_UNIT",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 4,
        "phase": "war",
        "stage": "movement",
        "playerColor": "red"
      },
      "action": {
        "type": "MOVE_UNIT",
        "payload": {
          "unitId": "u_red_8_9_-7",
          "unitType": "unit_d12",
          "newHexKey": "8,-6"
        }
      }
    },
    {
      "id": "entry_112_ADD_PENDING_MOVEMENT_ACTION",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 4,
        "phase": "war",
        "stage": "movement",
        "playerColor": "red"
      },
      "action": {
        "type": "ADD_PENDING_MOVEMENT_ACTION",
        "payload": {
          "unitId": "u_red_8_9_-7",
          "fromHexKey": "9,-7",
          "toHexKey": "8,-6",
          "additionalSupply": false
        }
      }
    },
    {
      "id": "entry_113_APPLY_MOVEMENT_ACTIONS",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 4,
        "phase": "war",
        "stage": "movement",
        "playerColor": "red"
      },
      "action": {
        "type": "APPLY_MOVEMENT_ACTIONS",
        "payload": {}
      }
    },
    {
      "id": "entry_114_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 4,
        "phase": "war",
        "stage": "movement",
        "playerColor": "red"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 4,
          "currentPlayerId": "player_id_red",
          "phase": "war",
          "warPhaseStage": "movement"
        }
      }
    },
    {
      "id": "entry_115_APPLY_RECRUITMENT_ACTIONS",
      "kind": "action",
      "playerColor": "light_green",
      "moment": {
        "round": 4,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "light_green"
      },
      "action": {
        "type": "APPLY_RECRUITMENT_ACTIONS",
        "payload": {}
      }
    },
    {
      "id": "entry_116_SET_WAR_PHASE_STAGE",
      "kind": "action",
      "playerColor": "light_green",
      "moment": {
        "round": 4,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "light_green"
      },
      "action": {
        "type": "SET_WAR_PHASE_STAGE",
        "payload": {
          "stage": "movement",
          "timestamp": 1700000000000,
          "round": 4,
          "currentPlayerId": "player_id_light_green",
          "phase": "war",
          "warPhaseStage": "recruitment"
        }
      }
    },
    {
      "id": "entry_117_APPLY_MOVEMENT_ACTIONS",
      "kind": "action",
      "playerColor": "light_green",
      "moment": {
        "round": 4,
        "phase": "war",
        "stage": "movement",
        "playerColor": "light_green"
      },
      "action": {
        "type": "APPLY_MOVEMENT_ACTIONS",
        "payload": {}
      }
    },
    {
      "id": "entry_118_SET_WAR_PHASE_STAGE",
      "kind": "action",
      "playerColor": "light_green",
      "moment": {
        "round": 4,
        "phase": "war",
        "stage": "movement",
        "playerColor": "light_green"
      },
      "action": {
        "type": "SET_WAR_PHASE_STAGE",
        "payload": {
          "stage": "shooting",
          "timestamp": 1700000000000,
          "round": 4,
          "currentPlayerId": "player_id_light_green",
          "phase": "war",
          "warPhaseStage": "movement"
        }
      }
    },
    {
      "id": "entry_119_APPLY_SHOOTING_ACTIONS",
      "kind": "action",
      "playerColor": "light_green",
      "moment": {
        "round": 4,
        "phase": "war",
        "stage": "shooting",
        "playerColor": "light_green"
      },
      "action": {
        "type": "APPLY_SHOOTING_ACTIONS",
        "payload": {}
      }
    },
    {
      "id": "entry_120_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "light_green",
      "moment": {
        "round": 4,
        "phase": "war",
        "stage": "shooting",
        "playerColor": "light_green"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 4,
          "currentPlayerId": "player_id_light_green",
          "phase": "war",
          "warPhaseStage": "shooting"
        }
      }
    },
    {
      "id": "entry_121_CAPTURE_CITIES",
      "kind": "action",
      "playerColor": "light_green",
      "moment": {
        "round": 4,
        "phase": "war",
        "stage": "shooting",
        "playerColor": "light_green"
      },
      "action": {
        "type": "CAPTURE_CITIES",
        "payload": {
          "round": 4,
          "phase": "war"
        }
      }
    },
    {
      "id": "entry_122_START_NEXT_PHASE",
      "kind": "action",
      "playerColor": "light_green",
      "moment": {
        "round": 4,
        "phase": "war",
        "stage": "shooting",
        "playerColor": "light_green"
      },
      "action": {
        "type": "START_NEXT_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "newPolicy": {
            "id": "agrarianism",
            "name": "Аграризм",
            "description": "Скидка на Ферму и Склад\nОбмен снабжения на монеты",
            "implemented": true,
            "color": "#D68A5A"
          },
          "round": 4,
          "currentPlayerId": "player_id_light_green",
          "phase": "war",
          "warPhaseStage": "shooting"
        }
      }
    },
    {
      "id": "entry_123_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 5,
        "phase": "supply",
        "stage": null,
        "playerColor": "red"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "9,-8",
          "unitId": "u_red_5_-1_0",
          "unitHexKey": "-1,0",
          "isAutoSupply": true,
          "isNotUndoable": false
        }
      }
    },
    {
      "id": "entry_124_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 5,
        "phase": "supply",
        "stage": null,
        "playerColor": "red"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "10,-9",
          "unitId": "u_red_6_2_-3",
          "unitHexKey": "2,-3",
          "isAutoSupply": true,
          "isNotUndoable": false
        }
      }
    },
    {
      "id": "entry_125_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 5,
        "phase": "supply",
        "stage": null,
        "playerColor": "red"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "11,-8",
          "unitId": "u_red_7_4_-4",
          "unitHexKey": "4,-4",
          "isAutoSupply": true,
          "isNotUndoable": false
        }
      }
    },
    {
      "id": "entry_126_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 5,
        "phase": "supply",
        "stage": null,
        "playerColor": "red"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "10,-7",
          "unitId": "u_red_8_9_-7",
          "unitHexKey": "8,-6",
          "isAutoSupply": true,
          "isNotUndoable": false
        }
      }
    },
    {
      "id": "entry_127_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 5,
        "phase": "supply",
        "stage": null,
        "playerColor": "red"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 5,
          "currentPlayerId": "player_id_red",
          "phase": "supply",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_128_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "light_green",
      "moment": {
        "round": 5,
        "phase": "supply",
        "stage": null,
        "playerColor": "light_green"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "6,-4",
          "unitId": "u_light_green_10_7_-4",
          "unitHexKey": "7,-4",
          "isAutoSupply": true,
          "isNotUndoable": false
        }
      }
    },
    {
      "id": "entry_129_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "light_green",
      "moment": {
        "round": 5,
        "phase": "supply",
        "stage": null,
        "playerColor": "light_green"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "5,-3",
          "unitId": "u_light_green_9_6_-3",
          "unitHexKey": "6,-3",
          "isAutoSupply": true,
          "isNotUndoable": false
        }
      }
    },
    {
      "id": "entry_130_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "light_green",
      "moment": {
        "round": 5,
        "phase": "supply",
        "stage": null,
        "playerColor": "light_green"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "6,-2",
          "unitId": "u_light_green_9_6_-3",
          "unitHexKey": "6,-3",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_131_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "light_green",
      "moment": {
        "round": 5,
        "phase": "supply",
        "stage": null,
        "playerColor": "light_green"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 5,
          "currentPlayerId": "player_id_light_green",
          "phase": "supply",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_132_START_NEXT_PHASE",
      "kind": "action",
      "playerColor": "light_green",
      "moment": {
        "round": 5,
        "phase": "supply",
        "stage": null,
        "playerColor": "light_green"
      },
      "action": {
        "type": "START_NEXT_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "newPolicy": {
            "id": "fortificationism",
            "name": "Фортификационизм",
            "description": "Мгновенное строительство и скидка для крепостей\nБонус к урону рядом с крепостью",
            "implemented": true,
            "color": "#865333"
          },
          "round": 5,
          "currentPlayerId": "player_id_light_green",
          "phase": "supply",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_133_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 5,
        "phase": "construction",
        "stage": null,
        "playerColor": "red"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 5,
          "currentPlayerId": "player_id_red",
          "phase": "construction",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_134_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "light_green",
      "moment": {
        "round": 5,
        "phase": "construction",
        "stage": null,
        "playerColor": "light_green"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 5,
          "currentPlayerId": "player_id_light_green",
          "phase": "construction",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_135_START_NEXT_PHASE",
      "kind": "action",
      "playerColor": "light_green",
      "moment": {
        "round": 5,
        "phase": "construction",
        "stage": null,
        "playerColor": "light_green"
      },
      "action": {
        "type": "START_NEXT_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "newPolicy": {
            "id": "servarianism",
            "name": "Серваризм",
            "description": "Увеличенный доход рудников,\nсмежных казармам и крупными отрядам",
            "implemented": true,
            "color": "#DEA806"
          },
          "round": 5,
          "currentPlayerId": "player_id_light_green",
          "phase": "construction",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "e_136_replica",
      "moment": {
        "round": 5,
        "phase": "war",
        "stage": "movement",
        "playerColor": "blue"
      },
      "kind": "replica",
      "replica": {
        "text": "Легат, карниз чист, но… там выше — следы. Драки. Только… …они там дрались МЕЖДУ СОБОЙ, легат. Красные метки — против серых. И проигравших… Разреши не докладывать подробно.",
        "characterName": "Дозорный",
        "side": "left",
        "characterImage": "/img/campaigns/humans/m5_dozorny.png"
      }
    },
    {
      "id": "e_137_replica",
      "moment": {
        "round": 5,
        "phase": "war",
        "stage": "movement",
        "playerColor": "blue"
      },
      "kind": "replica",
      "replica": {
        "text": "Не разрешаю. Докладывай. Я должен знать, что здесь происходит.",
        "characterName": "Луций",
        "side": "left",
        "characterImage": "/img/campaigns/humans/m5_lucius_stern.png"
      }
    },
    {
      "id": "e_138_replica",
      "moment": {
        "round": 5,
        "phase": "war",
        "stage": "movement",
        "playerColor": "blue"
      },
      "kind": "replica",
      "replica": {
        "text": "Они добивают своих отставших, легат. Тех, кто не может идти. А которые красные — те и не хоронят… Всё, легат. Прости.",
        "characterName": "Дозорный",
        "side": "left",
        "characterImage": "/img/campaigns/humans/m5_dozorny.png"
      }
    },
    {
      "id": "e_139_replica",
      "moment": {
        "round": 5,
        "phase": "war",
        "stage": "movement",
        "playerColor": "blue"
      },
      "kind": "replica",
      "replica": {
        "text": "Слышал, легат? Они жрут СВОИХ. Вот с кем ты собрался говорить у перевала, если там есть с кем говорить.",
        "characterName": "Барба",
        "side": "left",
        "characterImage": "/img/campaigns/humans/m5_barba_dark.png"
      }
    },
    {
      "id": "e_140_replica",
      "moment": {
        "round": 5,
        "phase": "war",
        "stage": "movement",
        "playerColor": "blue"
      },
      "kind": "replica",
      "replica": {
        "text": "Нет, старик. Красные жрут серых. Это разное. …Прости. Я знаю, что тебе сделали. Но это — разное. У нас тоже были свои «красные». Мой муж рубился с ними раньше, чем с вами.",
        "characterName": "Ильва",
        "side": "right",
        "characterImage": "/img/campaigns/humans/m5_ilva_firm.png"
      }
    },
    {
      "id": "entry_141_APPLY_RECRUITMENT_ACTIONS",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 5,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "red"
      },
      "action": {
        "type": "APPLY_RECRUITMENT_ACTIONS",
        "payload": {}
      }
    },
    {
      "id": "entry_142_SET_WAR_PHASE_STAGE",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 5,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "red"
      },
      "action": {
        "type": "SET_WAR_PHASE_STAGE",
        "payload": {
          "stage": "movement",
          "timestamp": 1700000000000,
          "round": 5,
          "currentPlayerId": "player_id_red",
          "phase": "war",
          "warPhaseStage": "recruitment"
        }
      }
    },
    {
      "id": "entry_143_APPLY_MOVEMENT_ACTIONS",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 5,
        "phase": "war",
        "stage": "movement",
        "playerColor": "red"
      },
      "action": {
        "type": "APPLY_MOVEMENT_ACTIONS",
        "payload": {}
      }
    },
    {
      "id": "entry_144_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 5,
        "phase": "war",
        "stage": "movement",
        "playerColor": "red"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 5,
          "currentPlayerId": "player_id_red",
          "phase": "war",
          "warPhaseStage": "movement"
        }
      }
    },
    {
      "id": "entry_145_APPLY_RECRUITMENT_ACTIONS",
      "kind": "action",
      "playerColor": "light_green",
      "moment": {
        "round": 5,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "light_green"
      },
      "action": {
        "type": "APPLY_RECRUITMENT_ACTIONS",
        "payload": {}
      }
    },
    {
      "id": "entry_146_SET_WAR_PHASE_STAGE",
      "kind": "action",
      "playerColor": "light_green",
      "moment": {
        "round": 5,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "light_green"
      },
      "action": {
        "type": "SET_WAR_PHASE_STAGE",
        "payload": {
          "stage": "movement",
          "timestamp": 1700000000000,
          "round": 5,
          "currentPlayerId": "player_id_light_green",
          "phase": "war",
          "warPhaseStage": "recruitment"
        }
      }
    },
    {
      "id": "entry_147_APPLY_MOVEMENT_ACTIONS",
      "kind": "action",
      "playerColor": "light_green",
      "moment": {
        "round": 5,
        "phase": "war",
        "stage": "movement",
        "playerColor": "light_green"
      },
      "action": {
        "type": "APPLY_MOVEMENT_ACTIONS",
        "payload": {}
      }
    },
    {
      "id": "entry_148_SET_WAR_PHASE_STAGE",
      "kind": "action",
      "playerColor": "light_green",
      "moment": {
        "round": 5,
        "phase": "war",
        "stage": "movement",
        "playerColor": "light_green"
      },
      "action": {
        "type": "SET_WAR_PHASE_STAGE",
        "payload": {
          "stage": "shooting",
          "timestamp": 1700000000000,
          "round": 5,
          "currentPlayerId": "player_id_light_green",
          "phase": "war",
          "warPhaseStage": "movement"
        }
      }
    },
    {
      "id": "entry_149_APPLY_SHOOTING_ACTIONS",
      "kind": "action",
      "playerColor": "light_green",
      "moment": {
        "round": 5,
        "phase": "war",
        "stage": "shooting",
        "playerColor": "light_green"
      },
      "action": {
        "type": "APPLY_SHOOTING_ACTIONS",
        "payload": {}
      }
    },
    {
      "id": "entry_150_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "light_green",
      "moment": {
        "round": 5,
        "phase": "war",
        "stage": "shooting",
        "playerColor": "light_green"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 5,
          "currentPlayerId": "player_id_light_green",
          "phase": "war",
          "warPhaseStage": "shooting"
        }
      }
    },
    {
      "id": "entry_151_CAPTURE_CITIES",
      "kind": "action",
      "playerColor": "light_green",
      "moment": {
        "round": 5,
        "phase": "war",
        "stage": "shooting",
        "playerColor": "light_green"
      },
      "action": {
        "type": "CAPTURE_CITIES",
        "payload": {
          "round": 5,
          "phase": "war"
        }
      }
    },
    {
      "id": "entry_152_START_NEXT_PHASE",
      "kind": "action",
      "playerColor": "light_green",
      "moment": {
        "round": 5,
        "phase": "war",
        "stage": "shooting",
        "playerColor": "light_green"
      },
      "action": {
        "type": "START_NEXT_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "newPolicy": {
            "id": "industrialism",
            "name": "Индустриализм",
            "description": "Дополнительное действие\nв фазе Строительства\nСкидка на особые строения",
            "implemented": true,
            "color": "#865333"
          },
          "round": 5,
          "currentPlayerId": "player_id_light_green",
          "phase": "war",
          "warPhaseStage": "shooting"
        }
      }
    },
    {
      "id": "entry_153_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 6,
        "phase": "supply",
        "stage": null,
        "playerColor": "red"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "9,-8",
          "unitId": "u_red_5_-1_0",
          "unitHexKey": "-1,0",
          "isAutoSupply": true,
          "isNotUndoable": false
        }
      }
    },
    {
      "id": "entry_154_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 6,
        "phase": "supply",
        "stage": null,
        "playerColor": "red"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "10,-9",
          "unitId": "u_red_6_2_-3",
          "unitHexKey": "2,-3",
          "isAutoSupply": true,
          "isNotUndoable": false
        }
      }
    },
    {
      "id": "entry_155_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 6,
        "phase": "supply",
        "stage": null,
        "playerColor": "red"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "11,-8",
          "unitId": "u_red_7_4_-4",
          "unitHexKey": "4,-4",
          "isAutoSupply": true,
          "isNotUndoable": false
        }
      }
    },
    {
      "id": "entry_156_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 6,
        "phase": "supply",
        "stage": null,
        "playerColor": "red"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "10,-7",
          "unitId": "u_red_8_9_-7",
          "unitHexKey": "8,-6",
          "isAutoSupply": true,
          "isNotUndoable": false
        }
      }
    },
    {
      "id": "entry_157_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 6,
        "phase": "supply",
        "stage": null,
        "playerColor": "red"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 6,
          "currentPlayerId": "player_id_red",
          "phase": "supply",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_158_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "light_green",
      "moment": {
        "round": 6,
        "phase": "supply",
        "stage": null,
        "playerColor": "light_green"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "6,-4",
          "unitId": "u_light_green_10_7_-4",
          "unitHexKey": "7,-4",
          "isAutoSupply": true,
          "isNotUndoable": false
        }
      }
    },
    {
      "id": "entry_159_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "light_green",
      "moment": {
        "round": 6,
        "phase": "supply",
        "stage": null,
        "playerColor": "light_green"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "5,-3",
          "unitId": "u_light_green_9_6_-3",
          "unitHexKey": "6,-3",
          "isAutoSupply": true,
          "isNotUndoable": false
        }
      }
    },
    {
      "id": "entry_160_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "light_green",
      "moment": {
        "round": 6,
        "phase": "supply",
        "stage": null,
        "playerColor": "light_green"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "6,-2",
          "unitId": "u_light_green_9_6_-3",
          "unitHexKey": "6,-3",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_161_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "light_green",
      "moment": {
        "round": 6,
        "phase": "supply",
        "stage": null,
        "playerColor": "light_green"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 6,
          "currentPlayerId": "player_id_light_green",
          "phase": "supply",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_162_START_NEXT_PHASE",
      "kind": "action",
      "playerColor": "light_green",
      "moment": {
        "round": 6,
        "phase": "supply",
        "stage": null,
        "playerColor": "light_green"
      },
      "action": {
        "type": "START_NEXT_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "newPolicy": {
            "id": "hegemonism",
            "name": "Гегемонизм",
            "description": "Бонус к доходу очков и урону в центре поля",
            "implemented": true,
            "color": "#A9A9A9"
          },
          "round": 6,
          "currentPlayerId": "player_id_light_green",
          "phase": "supply",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_163_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 6,
        "phase": "construction",
        "stage": null,
        "playerColor": "red"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 6,
          "currentPlayerId": "player_id_red",
          "phase": "construction",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_164_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "light_green",
      "moment": {
        "round": 6,
        "phase": "construction",
        "stage": null,
        "playerColor": "light_green"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 6,
          "currentPlayerId": "player_id_light_green",
          "phase": "construction",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_165_START_NEXT_PHASE",
      "kind": "action",
      "playerColor": "light_green",
      "moment": {
        "round": 6,
        "phase": "construction",
        "stage": null,
        "playerColor": "light_green"
      },
      "action": {
        "type": "START_NEXT_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "newPolicy": {
            "id": "oligarchy",
            "name": "Олигархия",
            "description": "2 гильдий в одном городе\nУвеличенный доход гильдий",
            "implemented": true,
            "color": "#DEA806"
          },
          "round": 6,
          "currentPlayerId": "player_id_light_green",
          "phase": "construction",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_166_APPLY_RECRUITMENT_ACTIONS",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 6,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "red"
      },
      "action": {
        "type": "APPLY_RECRUITMENT_ACTIONS",
        "payload": {}
      }
    },
    {
      "id": "entry_167_SET_WAR_PHASE_STAGE",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 6,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "red"
      },
      "action": {
        "type": "SET_WAR_PHASE_STAGE",
        "payload": {
          "stage": "movement",
          "timestamp": 1700000000000,
          "round": 6,
          "currentPlayerId": "player_id_red",
          "phase": "war",
          "warPhaseStage": "recruitment"
        }
      }
    },
    {
      "id": "entry_168_APPLY_MOVEMENT_ACTIONS",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 6,
        "phase": "war",
        "stage": "movement",
        "playerColor": "red"
      },
      "action": {
        "type": "APPLY_MOVEMENT_ACTIONS",
        "payload": {}
      }
    },
    {
      "id": "entry_169_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 6,
        "phase": "war",
        "stage": "movement",
        "playerColor": "red"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 6,
          "currentPlayerId": "player_id_red",
          "phase": "war",
          "warPhaseStage": "movement"
        }
      }
    },
    {
      "id": "entry_170_APPLY_RECRUITMENT_ACTIONS",
      "kind": "action",
      "playerColor": "light_green",
      "moment": {
        "round": 6,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "light_green"
      },
      "action": {
        "type": "APPLY_RECRUITMENT_ACTIONS",
        "payload": {}
      }
    },
    {
      "id": "entry_171_SET_WAR_PHASE_STAGE",
      "kind": "action",
      "playerColor": "light_green",
      "moment": {
        "round": 6,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "light_green"
      },
      "action": {
        "type": "SET_WAR_PHASE_STAGE",
        "payload": {
          "stage": "movement",
          "timestamp": 1700000000000,
          "round": 6,
          "currentPlayerId": "player_id_light_green",
          "phase": "war",
          "warPhaseStage": "recruitment"
        }
      }
    },
    {
      "id": "entry_172_APPLY_MOVEMENT_ACTIONS",
      "kind": "action",
      "playerColor": "light_green",
      "moment": {
        "round": 6,
        "phase": "war",
        "stage": "movement",
        "playerColor": "light_green"
      },
      "action": {
        "type": "APPLY_MOVEMENT_ACTIONS",
        "payload": {}
      }
    },
    {
      "id": "entry_173_SET_WAR_PHASE_STAGE",
      "kind": "action",
      "playerColor": "light_green",
      "moment": {
        "round": 6,
        "phase": "war",
        "stage": "movement",
        "playerColor": "light_green"
      },
      "action": {
        "type": "SET_WAR_PHASE_STAGE",
        "payload": {
          "stage": "shooting",
          "timestamp": 1700000000000,
          "round": 6,
          "currentPlayerId": "player_id_light_green",
          "phase": "war",
          "warPhaseStage": "movement"
        }
      }
    },
    {
      "id": "entry_174_APPLY_SHOOTING_ACTIONS",
      "kind": "action",
      "playerColor": "light_green",
      "moment": {
        "round": 6,
        "phase": "war",
        "stage": "shooting",
        "playerColor": "light_green"
      },
      "action": {
        "type": "APPLY_SHOOTING_ACTIONS",
        "payload": {}
      }
    },
    {
      "id": "entry_175_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "light_green",
      "moment": {
        "round": 6,
        "phase": "war",
        "stage": "shooting",
        "playerColor": "light_green"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 6,
          "currentPlayerId": "player_id_light_green",
          "phase": "war",
          "warPhaseStage": "shooting"
        }
      }
    },
    {
      "id": "entry_176_CAPTURE_CITIES",
      "kind": "action",
      "playerColor": "light_green",
      "moment": {
        "round": 6,
        "phase": "war",
        "stage": "shooting",
        "playerColor": "light_green"
      },
      "action": {
        "type": "CAPTURE_CITIES",
        "payload": {
          "round": 6,
          "phase": "war"
        }
      }
    },
    {
      "id": "entry_177_START_NEXT_PHASE",
      "kind": "action",
      "playerColor": "light_green",
      "moment": {
        "round": 6,
        "phase": "war",
        "stage": "shooting",
        "playerColor": "light_green"
      },
      "action": {
        "type": "START_NEXT_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "newPolicy": {
            "id": "industrialism",
            "name": "Индустриализм",
            "description": "Дополнительное действие\nв фазе Строительства\nСкидка на особые строения",
            "implemented": true,
            "color": "#865333"
          },
          "round": 6,
          "currentPlayerId": "player_id_light_green",
          "phase": "war",
          "warPhaseStage": "shooting"
        }
      }
    },
    {
      "id": "entry_178_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 7,
        "phase": "supply",
        "stage": null,
        "playerColor": "red"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "9,-8",
          "unitId": "u_red_5_-1_0",
          "unitHexKey": "-1,0",
          "isAutoSupply": true,
          "isNotUndoable": false
        }
      }
    },
    {
      "id": "entry_179_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 7,
        "phase": "supply",
        "stage": null,
        "playerColor": "red"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "10,-9",
          "unitId": "u_red_6_2_-3",
          "unitHexKey": "2,-3",
          "isAutoSupply": true,
          "isNotUndoable": false
        }
      }
    },
    {
      "id": "entry_180_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 7,
        "phase": "supply",
        "stage": null,
        "playerColor": "red"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "11,-8",
          "unitId": "u_red_7_4_-4",
          "unitHexKey": "4,-4",
          "isAutoSupply": true,
          "isNotUndoable": false
        }
      }
    },
    {
      "id": "entry_181_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 7,
        "phase": "supply",
        "stage": null,
        "playerColor": "red"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "10,-7",
          "unitId": "u_red_8_9_-7",
          "unitHexKey": "8,-6",
          "isAutoSupply": true,
          "isNotUndoable": false
        }
      }
    },
    {
      "id": "entry_182_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 7,
        "phase": "supply",
        "stage": null,
        "playerColor": "red"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 7,
          "currentPlayerId": "player_id_red",
          "phase": "supply",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_183_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "light_green",
      "moment": {
        "round": 7,
        "phase": "supply",
        "stage": null,
        "playerColor": "light_green"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "6,-4",
          "unitId": "u_light_green_10_7_-4",
          "unitHexKey": "7,-4",
          "isAutoSupply": true,
          "isNotUndoable": false
        }
      }
    },
    {
      "id": "entry_184_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "light_green",
      "moment": {
        "round": 7,
        "phase": "supply",
        "stage": null,
        "playerColor": "light_green"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "5,-3",
          "unitId": "u_light_green_9_6_-3",
          "unitHexKey": "6,-3",
          "isAutoSupply": true,
          "isNotUndoable": false
        }
      }
    },
    {
      "id": "entry_185_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "light_green",
      "moment": {
        "round": 7,
        "phase": "supply",
        "stage": null,
        "playerColor": "light_green"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "6,-2",
          "unitId": "u_light_green_9_6_-3",
          "unitHexKey": "6,-3",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_186_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "light_green",
      "moment": {
        "round": 7,
        "phase": "supply",
        "stage": null,
        "playerColor": "light_green"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 7,
          "currentPlayerId": "player_id_light_green",
          "phase": "supply",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_187_START_NEXT_PHASE",
      "kind": "action",
      "playerColor": "light_green",
      "moment": {
        "round": 7,
        "phase": "supply",
        "stage": null,
        "playerColor": "light_green"
      },
      "action": {
        "type": "START_NEXT_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "newPolicy": {
            "id": "militarism",
            "name": "Милитаризм",
            "description": "Увеличенный урон в ближнем бою",
            "implemented": true,
            "color": "#98172d"
          },
          "round": 7,
          "currentPlayerId": "player_id_light_green",
          "phase": "supply",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_188_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 7,
        "phase": "construction",
        "stage": null,
        "playerColor": "red"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 7,
          "currentPlayerId": "player_id_red",
          "phase": "construction",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_189_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "light_green",
      "moment": {
        "round": 7,
        "phase": "construction",
        "stage": null,
        "playerColor": "light_green"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 7,
          "currentPlayerId": "player_id_light_green",
          "phase": "construction",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_190_START_NEXT_PHASE",
      "kind": "action",
      "playerColor": "light_green",
      "moment": {
        "round": 7,
        "phase": "construction",
        "stage": null,
        "playerColor": "light_green"
      },
      "action": {
        "type": "START_NEXT_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "newPolicy": {
            "id": "militarism",
            "name": "Милитаризм",
            "description": "Увеличенный урон в ближнем бою",
            "implemented": true,
            "color": "#98172d"
          },
          "round": 7,
          "currentPlayerId": "player_id_light_green",
          "phase": "construction",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_191_APPLY_RECRUITMENT_ACTIONS",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 7,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "red"
      },
      "action": {
        "type": "APPLY_RECRUITMENT_ACTIONS",
        "payload": {}
      }
    },
    {
      "id": "entry_192_SET_WAR_PHASE_STAGE",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 7,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "red"
      },
      "action": {
        "type": "SET_WAR_PHASE_STAGE",
        "payload": {
          "stage": "movement",
          "timestamp": 1700000000000,
          "round": 7,
          "currentPlayerId": "player_id_red",
          "phase": "war",
          "warPhaseStage": "recruitment"
        }
      }
    },
    {
      "id": "entry_193_APPLY_MOVEMENT_ACTIONS",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 7,
        "phase": "war",
        "stage": "movement",
        "playerColor": "red"
      },
      "action": {
        "type": "APPLY_MOVEMENT_ACTIONS",
        "payload": {}
      }
    },
    {
      "id": "entry_194_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 7,
        "phase": "war",
        "stage": "movement",
        "playerColor": "red"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 7,
          "currentPlayerId": "player_id_red",
          "phase": "war",
          "warPhaseStage": "movement"
        }
      }
    },
    {
      "id": "entry_195_APPLY_RECRUITMENT_ACTIONS",
      "kind": "action",
      "playerColor": "light_green",
      "moment": {
        "round": 7,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "light_green"
      },
      "action": {
        "type": "APPLY_RECRUITMENT_ACTIONS",
        "payload": {}
      }
    },
    {
      "id": "entry_196_SET_WAR_PHASE_STAGE",
      "kind": "action",
      "playerColor": "light_green",
      "moment": {
        "round": 7,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "light_green"
      },
      "action": {
        "type": "SET_WAR_PHASE_STAGE",
        "payload": {
          "stage": "movement",
          "timestamp": 1700000000000,
          "round": 7,
          "currentPlayerId": "player_id_light_green",
          "phase": "war",
          "warPhaseStage": "recruitment"
        }
      }
    },
    {
      "id": "entry_197_APPLY_MOVEMENT_ACTIONS",
      "kind": "action",
      "playerColor": "light_green",
      "moment": {
        "round": 7,
        "phase": "war",
        "stage": "movement",
        "playerColor": "light_green"
      },
      "action": {
        "type": "APPLY_MOVEMENT_ACTIONS",
        "payload": {}
      }
    },
    {
      "id": "entry_198_SET_WAR_PHASE_STAGE",
      "kind": "action",
      "playerColor": "light_green",
      "moment": {
        "round": 7,
        "phase": "war",
        "stage": "movement",
        "playerColor": "light_green"
      },
      "action": {
        "type": "SET_WAR_PHASE_STAGE",
        "payload": {
          "stage": "shooting",
          "timestamp": 1700000000000,
          "round": 7,
          "currentPlayerId": "player_id_light_green",
          "phase": "war",
          "warPhaseStage": "movement"
        }
      }
    },
    {
      "id": "entry_199_APPLY_SHOOTING_ACTIONS",
      "kind": "action",
      "playerColor": "light_green",
      "moment": {
        "round": 7,
        "phase": "war",
        "stage": "shooting",
        "playerColor": "light_green"
      },
      "action": {
        "type": "APPLY_SHOOTING_ACTIONS",
        "payload": {}
      }
    },
    {
      "id": "entry_200_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "light_green",
      "moment": {
        "round": 7,
        "phase": "war",
        "stage": "shooting",
        "playerColor": "light_green"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 7,
          "currentPlayerId": "player_id_light_green",
          "phase": "war",
          "warPhaseStage": "shooting"
        }
      }
    },
    {
      "id": "entry_201_CAPTURE_CITIES",
      "kind": "action",
      "playerColor": "light_green",
      "moment": {
        "round": 7,
        "phase": "war",
        "stage": "shooting",
        "playerColor": "light_green"
      },
      "action": {
        "type": "CAPTURE_CITIES",
        "payload": {
          "round": 7,
          "phase": "war"
        }
      }
    },
    {
      "id": "entry_202_START_NEXT_PHASE",
      "kind": "action",
      "playerColor": "light_green",
      "moment": {
        "round": 7,
        "phase": "war",
        "stage": "shooting",
        "playerColor": "light_green"
      },
      "action": {
        "type": "START_NEXT_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "newPolicy": {
            "id": "agrarianism",
            "name": "Аграризм",
            "description": "Скидка на Ферму и Склад\nОбмен снабжения на монеты",
            "implemented": true,
            "color": "#D68A5A"
          },
          "round": 7,
          "currentPlayerId": "player_id_light_green",
          "phase": "war",
          "warPhaseStage": "shooting"
        }
      }
    },
    {
      "id": "entry_203_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 8,
        "phase": "supply",
        "stage": null,
        "playerColor": "red"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "9,-8",
          "unitId": "u_red_5_-1_0",
          "unitHexKey": "-1,0",
          "isAutoSupply": true,
          "isNotUndoable": false
        }
      }
    },
    {
      "id": "entry_204_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 8,
        "phase": "supply",
        "stage": null,
        "playerColor": "red"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "10,-9",
          "unitId": "u_red_6_2_-3",
          "unitHexKey": "2,-3",
          "isAutoSupply": true,
          "isNotUndoable": false
        }
      }
    },
    {
      "id": "entry_205_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 8,
        "phase": "supply",
        "stage": null,
        "playerColor": "red"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "11,-8",
          "unitId": "u_red_7_4_-4",
          "unitHexKey": "4,-4",
          "isAutoSupply": true,
          "isNotUndoable": false
        }
      }
    },
    {
      "id": "entry_206_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 8,
        "phase": "supply",
        "stage": null,
        "playerColor": "red"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "10,-7",
          "unitId": "u_red_8_9_-7",
          "unitHexKey": "8,-6",
          "isAutoSupply": true,
          "isNotUndoable": false
        }
      }
    },
    {
      "id": "entry_207_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 8,
        "phase": "supply",
        "stage": null,
        "playerColor": "red"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 8,
          "currentPlayerId": "player_id_red",
          "phase": "supply",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_208_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "light_green",
      "moment": {
        "round": 8,
        "phase": "supply",
        "stage": null,
        "playerColor": "light_green"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "6,-4",
          "unitId": "u_light_green_10_7_-4",
          "unitHexKey": "7,-4",
          "isAutoSupply": true,
          "isNotUndoable": false
        }
      }
    },
    {
      "id": "entry_209_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "light_green",
      "moment": {
        "round": 8,
        "phase": "supply",
        "stage": null,
        "playerColor": "light_green"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "5,-3",
          "unitId": "u_light_green_9_6_-3",
          "unitHexKey": "6,-3",
          "isAutoSupply": true,
          "isNotUndoable": false
        }
      }
    },
    {
      "id": "entry_210_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "light_green",
      "moment": {
        "round": 8,
        "phase": "supply",
        "stage": null,
        "playerColor": "light_green"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "6,-2",
          "unitId": "u_light_green_9_6_-3",
          "unitHexKey": "6,-3",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_211_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "light_green",
      "moment": {
        "round": 8,
        "phase": "supply",
        "stage": null,
        "playerColor": "light_green"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 8,
          "currentPlayerId": "player_id_light_green",
          "phase": "supply",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_212_START_NEXT_PHASE",
      "kind": "action",
      "playerColor": "light_green",
      "moment": {
        "round": 8,
        "phase": "supply",
        "stage": null,
        "playerColor": "light_green"
      },
      "action": {
        "type": "START_NEXT_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "newPolicy": {
            "id": "hegemonism",
            "name": "Гегемонизм",
            "description": "Бонус к доходу очков и урону в центре поля",
            "implemented": true,
            "color": "#A9A9A9"
          },
          "round": 8,
          "currentPlayerId": "player_id_light_green",
          "phase": "supply",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_213_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 8,
        "phase": "construction",
        "stage": null,
        "playerColor": "red"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 8,
          "currentPlayerId": "player_id_red",
          "phase": "construction",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_214_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "light_green",
      "moment": {
        "round": 8,
        "phase": "construction",
        "stage": null,
        "playerColor": "light_green"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 8,
          "currentPlayerId": "player_id_light_green",
          "phase": "construction",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_215_START_NEXT_PHASE",
      "kind": "action",
      "playerColor": "light_green",
      "moment": {
        "round": 8,
        "phase": "construction",
        "stage": null,
        "playerColor": "light_green"
      },
      "action": {
        "type": "START_NEXT_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "newPolicy": {
            "id": "barbarism",
            "name": "Варварство",
            "description": "Бесплатный наем Пехоты\nУвеличенный урон в ближнем бою\nОчки за урон",
            "implemented": true,
            "color": "#98172d"
          },
          "round": 8,
          "currentPlayerId": "player_id_light_green",
          "phase": "construction",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "e_216_replica",
      "moment": {
        "round": 8,
        "phase": "war",
        "stage": "movement",
        "playerColor": "blue"
      },
      "kind": "replica",
      "replica": {
        "text": "Лагерь по фронту, легат! Орки!.. Орки… стоят. Не бегут, не атакуют. Просто… встали. Все. Между нами и… там у них мелкие, легат. Они мелких за спины прячут.",
        "characterName": "Дозорный",
        "side": "left",
        "characterImage": "/img/campaigns/humans/m5_dozorny.png"
      }
    },
    {
      "id": "e_217_replica",
      "moment": {
        "round": 8,
        "phase": "war",
        "stage": "movement",
        "playerColor": "blue"
      },
      "kind": "replica",
      "replica": {
        "text": "…Руки. У того, крайнего, — руки в мозолях от волокуш. Не от секир. Квинт. Ты видишь то же, что я?",
        "characterName": "Луций",
        "side": "left",
        "characterImage": "/img/campaigns/humans/m5_lucius_doubt.png"
      }
    },
    {
      "id": "e_218_replica",
      "moment": {
        "round": 8,
        "phase": "war",
        "stage": "movement",
        "playerColor": "blue"
      },
      "kind": "replica",
      "replica": {
        "text": "Вижу, легат. Вижу ОРКОВ. Я видел такие же спины у отвалов Бессы — только те спины были ЛЮДСКИЕ, и это ОНИ их согнули. Я не прошу резни. Я прошу СЧЁТА. Сорок Атилия. Верцелльские рвы. Мой… Не мне одному тут должны, легат.",
        "characterName": "Барба",
        "side": "left",
        "characterImage": "/img/campaigns/humans/m5_barba_dark.png"
      }
    },
    {
      "id": "e_219_replica",
      "moment": {
        "round": 8,
        "phase": "war",
        "stage": "movement",
        "playerColor": "blue"
      },
      "kind": "replica",
      "replica": {
        "text": "Сорок моих стояли так же, легат. Между ними и своими. Решай что хочешь — я исполню любое. Просто знай: я узнал позу.",
        "characterName": "Атилий",
        "side": "left",
        "characterImage": "/img/campaigns/humans/m5_atilius_calm.png"
      }
    },
    {
      "id": "e_220_replica",
      "moment": {
        "round": 8,
        "phase": "war",
        "stage": "movement",
        "playerColor": "blue"
      },
      "kind": "replica",
      "replica": {
        "text": "И я узнал… Я в ней уже стоял. С другой стороны. Корпус — стоять. Оружие — опустить. Атилий — дозоры по гребню. Писарю — записать в журнал похода: стойбище пощадил — я, Луций Аврелий Скавр, своей волей. Взыскивать — с меня.",
        "characterName": "Луций",
        "side": "left",
        "characterImage": "/img/campaigns/humans/m5_lucius_resolve.png"
      }
    },
    {
      "id": "e_221_replica",
      "moment": {
        "round": 8,
        "phase": "war",
        "stage": "movement",
        "playerColor": "blue"
      },
      "kind": "replica",
      "replica": {
        "text": "…Понял. Легат.",
        "characterName": "Барба",
        "side": "left",
        "characterImage": "/img/campaigns/humans/m5_barba_broken.png"
      }
    },
    {
      "id": "e_222_replica",
      "moment": {
        "round": 8,
        "phase": "war",
        "stage": "movement",
        "playerColor": "blue"
      },
      "kind": "replica",
      "replica": {
        "text": "Квинт…",
        "characterName": "Луций",
        "side": "left",
        "characterImage": "/img/campaigns/humans/m5_lucius_doubt.png"
      }
    },
    {
      "id": "e_223_replica",
      "moment": {
        "round": 8,
        "phase": "war",
        "stage": "movement",
        "playerColor": "blue"
      },
      "kind": "replica",
      "replica": {
        "text": "Приказ понял, легат. Исполняю.",
        "characterName": "Барба",
        "side": "left",
        "characterImage": "/img/campaigns/humans/m5_barba_broken.png"
      }
    },
    {
      "id": "entry_224_APPLY_RECRUITMENT_ACTIONS",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 8,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "red"
      },
      "action": {
        "type": "APPLY_RECRUITMENT_ACTIONS",
        "payload": {}
      }
    },
    {
      "id": "entry_225_SET_WAR_PHASE_STAGE",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 8,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "red"
      },
      "action": {
        "type": "SET_WAR_PHASE_STAGE",
        "payload": {
          "stage": "movement",
          "timestamp": 1700000000000,
          "round": 8,
          "currentPlayerId": "player_id_red",
          "phase": "war",
          "warPhaseStage": "recruitment"
        }
      }
    },
    {
      "id": "entry_226_MOVE_UNIT",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 8,
        "phase": "war",
        "stage": "movement",
        "playerColor": "red"
      },
      "action": {
        "type": "MOVE_UNIT",
        "payload": {
          "unitId": "u_red_8_9_-7",
          "unitType": "unit_d12",
          "newHexKey": "7,-6"
        }
      }
    },
    {
      "id": "entry_227_ADD_PENDING_MOVEMENT_ACTION",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 8,
        "phase": "war",
        "stage": "movement",
        "playerColor": "red"
      },
      "action": {
        "type": "ADD_PENDING_MOVEMENT_ACTION",
        "payload": {
          "unitId": "u_red_8_9_-7",
          "fromHexKey": "8,-6",
          "toHexKey": "7,-6",
          "additionalSupply": false
        }
      }
    },
    {
      "id": "entry_228_APPLY_MOVEMENT_ACTIONS",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 8,
        "phase": "war",
        "stage": "movement",
        "playerColor": "red"
      },
      "action": {
        "type": "APPLY_MOVEMENT_ACTIONS",
        "payload": {}
      }
    },
    {
      "id": "entry_229_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 8,
        "phase": "war",
        "stage": "movement",
        "playerColor": "red"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 8,
          "currentPlayerId": "player_id_red",
          "phase": "war",
          "warPhaseStage": "movement"
        }
      }
    },
    {
      "id": "entry_230_APPLY_RECRUITMENT_ACTIONS",
      "kind": "action",
      "playerColor": "light_green",
      "moment": {
        "round": 8,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "light_green"
      },
      "action": {
        "type": "APPLY_RECRUITMENT_ACTIONS",
        "payload": {}
      }
    },
    {
      "id": "entry_231_SET_WAR_PHASE_STAGE",
      "kind": "action",
      "playerColor": "light_green",
      "moment": {
        "round": 8,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "light_green"
      },
      "action": {
        "type": "SET_WAR_PHASE_STAGE",
        "payload": {
          "stage": "movement",
          "timestamp": 1700000000000,
          "round": 8,
          "currentPlayerId": "player_id_light_green",
          "phase": "war",
          "warPhaseStage": "recruitment"
        }
      }
    },
    {
      "id": "entry_232_APPLY_MOVEMENT_ACTIONS",
      "kind": "action",
      "playerColor": "light_green",
      "moment": {
        "round": 8,
        "phase": "war",
        "stage": "movement",
        "playerColor": "light_green"
      },
      "action": {
        "type": "APPLY_MOVEMENT_ACTIONS",
        "payload": {}
      }
    },
    {
      "id": "entry_233_SET_WAR_PHASE_STAGE",
      "kind": "action",
      "playerColor": "light_green",
      "moment": {
        "round": 8,
        "phase": "war",
        "stage": "movement",
        "playerColor": "light_green"
      },
      "action": {
        "type": "SET_WAR_PHASE_STAGE",
        "payload": {
          "stage": "shooting",
          "timestamp": 1700000000000,
          "round": 8,
          "currentPlayerId": "player_id_light_green",
          "phase": "war",
          "warPhaseStage": "movement"
        }
      }
    },
    {
      "id": "entry_234_APPLY_SHOOTING_ACTIONS",
      "kind": "action",
      "playerColor": "light_green",
      "moment": {
        "round": 8,
        "phase": "war",
        "stage": "shooting",
        "playerColor": "light_green"
      },
      "action": {
        "type": "APPLY_SHOOTING_ACTIONS",
        "payload": {}
      }
    },
    {
      "id": "entry_235_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "light_green",
      "moment": {
        "round": 8,
        "phase": "war",
        "stage": "shooting",
        "playerColor": "light_green"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 8,
          "currentPlayerId": "player_id_light_green",
          "phase": "war",
          "warPhaseStage": "shooting"
        }
      }
    },
    {
      "id": "entry_236_CAPTURE_CITIES",
      "kind": "action",
      "playerColor": "light_green",
      "moment": {
        "round": 8,
        "phase": "war",
        "stage": "shooting",
        "playerColor": "light_green"
      },
      "action": {
        "type": "CAPTURE_CITIES",
        "payload": {
          "round": 8,
          "phase": "war"
        }
      }
    },
    {
      "id": "entry_237_START_NEXT_PHASE",
      "kind": "action",
      "playerColor": "light_green",
      "moment": {
        "round": 8,
        "phase": "war",
        "stage": "shooting",
        "playerColor": "light_green"
      },
      "action": {
        "type": "START_NEXT_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "newPolicy": {
            "id": "totalitarianism",
            "name": "Тоталитаризм",
            "description": "Очки за военные строения\nСкидка на Лагерь и Арсенал\nНайм отрядов увеличенного размера",
            "implemented": true,
            "color": "#98172d"
          },
          "round": 8,
          "currentPlayerId": "player_id_light_green",
          "phase": "war",
          "warPhaseStage": "shooting"
        }
      }
    },
    {
      "id": "entry_238_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 9,
        "phase": "supply",
        "stage": null,
        "playerColor": "red"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "9,-8",
          "unitId": "u_red_5_-1_0",
          "unitHexKey": "-1,0",
          "isAutoSupply": true,
          "isNotUndoable": false
        }
      }
    },
    {
      "id": "entry_239_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 9,
        "phase": "supply",
        "stage": null,
        "playerColor": "red"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "10,-9",
          "unitId": "u_red_6_2_-3",
          "unitHexKey": "2,-3",
          "isAutoSupply": true,
          "isNotUndoable": false
        }
      }
    },
    {
      "id": "entry_240_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 9,
        "phase": "supply",
        "stage": null,
        "playerColor": "red"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "11,-8",
          "unitId": "u_red_7_4_-4",
          "unitHexKey": "4,-4",
          "isAutoSupply": true,
          "isNotUndoable": false
        }
      }
    },
    {
      "id": "entry_241_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 9,
        "phase": "supply",
        "stage": null,
        "playerColor": "red"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "10,-7",
          "unitId": "u_red_8_9_-7",
          "unitHexKey": "7,-6",
          "isAutoSupply": true,
          "isNotUndoable": false
        }
      }
    },
    {
      "id": "entry_242_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 9,
        "phase": "supply",
        "stage": null,
        "playerColor": "red"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 9,
          "currentPlayerId": "player_id_red",
          "phase": "supply",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_243_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "light_green",
      "moment": {
        "round": 9,
        "phase": "supply",
        "stage": null,
        "playerColor": "light_green"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "6,-4",
          "unitId": "u_light_green_10_7_-4",
          "unitHexKey": "7,-4",
          "isAutoSupply": true,
          "isNotUndoable": false
        }
      }
    },
    {
      "id": "entry_244_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "light_green",
      "moment": {
        "round": 9,
        "phase": "supply",
        "stage": null,
        "playerColor": "light_green"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "5,-3",
          "unitId": "u_light_green_9_6_-3",
          "unitHexKey": "6,-3",
          "isAutoSupply": true,
          "isNotUndoable": false
        }
      }
    },
    {
      "id": "entry_245_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "light_green",
      "moment": {
        "round": 9,
        "phase": "supply",
        "stage": null,
        "playerColor": "light_green"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "6,-2",
          "unitId": "u_light_green_9_6_-3",
          "unitHexKey": "6,-3",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_246_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "light_green",
      "moment": {
        "round": 9,
        "phase": "supply",
        "stage": null,
        "playerColor": "light_green"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 9,
          "currentPlayerId": "player_id_light_green",
          "phase": "supply",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_247_START_NEXT_PHASE",
      "kind": "action",
      "playerColor": "light_green",
      "moment": {
        "round": 9,
        "phase": "supply",
        "stage": null,
        "playerColor": "light_green"
      },
      "action": {
        "type": "START_NEXT_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "newPolicy": {
            "id": "patriotism",
            "name": "Патриотизм",
            "description": "Скидка на найм размера отрядов и Арсенал",
            "implemented": true,
            "color": "#98172d"
          },
          "round": 9,
          "currentPlayerId": "player_id_light_green",
          "phase": "supply",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_248_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 9,
        "phase": "construction",
        "stage": null,
        "playerColor": "red"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 9,
          "currentPlayerId": "player_id_red",
          "phase": "construction",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_249_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "light_green",
      "moment": {
        "round": 9,
        "phase": "construction",
        "stage": null,
        "playerColor": "light_green"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 9,
          "currentPlayerId": "player_id_light_green",
          "phase": "construction",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_250_START_NEXT_PHASE",
      "kind": "action",
      "playerColor": "light_green",
      "moment": {
        "round": 9,
        "phase": "construction",
        "stage": null,
        "playerColor": "light_green"
      },
      "action": {
        "type": "START_NEXT_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "newPolicy": {
            "id": "isolationism",
            "name": "Изоляционизм",
            "description": "Защита права первого хода\nСкидка на особые строения\nБонус к урону отрядов в своих городах",
            "implemented": true,
            "color": "#b09292"
          },
          "round": 9,
          "currentPlayerId": "player_id_light_green",
          "phase": "construction",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_251_APPLY_RECRUITMENT_ACTIONS",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 9,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "red"
      },
      "action": {
        "type": "APPLY_RECRUITMENT_ACTIONS",
        "payload": {}
      }
    },
    {
      "id": "entry_252_SET_WAR_PHASE_STAGE",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 9,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "red"
      },
      "action": {
        "type": "SET_WAR_PHASE_STAGE",
        "payload": {
          "stage": "movement",
          "timestamp": 1700000000000,
          "round": 9,
          "currentPlayerId": "player_id_red",
          "phase": "war",
          "warPhaseStage": "recruitment"
        }
      }
    },
    {
      "id": "entry_253_MOVE_UNIT",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 9,
        "phase": "war",
        "stage": "movement",
        "playerColor": "red"
      },
      "action": {
        "type": "MOVE_UNIT",
        "payload": {
          "unitId": "u_red_7_4_-4",
          "unitType": "unit_d10",
          "newHexKey": "5,-4"
        }
      }
    },
    {
      "id": "entry_254_ADD_PENDING_MOVEMENT_ACTION",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 9,
        "phase": "war",
        "stage": "movement",
        "playerColor": "red"
      },
      "action": {
        "type": "ADD_PENDING_MOVEMENT_ACTION",
        "payload": {
          "unitId": "u_red_7_4_-4",
          "fromHexKey": "4,-4",
          "toHexKey": "5,-4",
          "additionalSupply": false
        }
      }
    },
    {
      "id": "entry_255_APPLY_MOVEMENT_ACTIONS",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 9,
        "phase": "war",
        "stage": "movement",
        "playerColor": "red"
      },
      "action": {
        "type": "APPLY_MOVEMENT_ACTIONS",
        "payload": {}
      }
    },
    {
      "id": "entry_256_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 9,
        "phase": "war",
        "stage": "movement",
        "playerColor": "red"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 9,
          "currentPlayerId": "player_id_red",
          "phase": "war",
          "warPhaseStage": "movement"
        }
      }
    },
    {
      "id": "entry_257_APPLY_RECRUITMENT_ACTIONS",
      "kind": "action",
      "playerColor": "light_green",
      "moment": {
        "round": 9,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "light_green"
      },
      "action": {
        "type": "APPLY_RECRUITMENT_ACTIONS",
        "payload": {}
      }
    },
    {
      "id": "entry_258_SET_WAR_PHASE_STAGE",
      "kind": "action",
      "playerColor": "light_green",
      "moment": {
        "round": 9,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "light_green"
      },
      "action": {
        "type": "SET_WAR_PHASE_STAGE",
        "payload": {
          "stage": "movement",
          "timestamp": 1700000000000,
          "round": 9,
          "currentPlayerId": "player_id_light_green",
          "phase": "war",
          "warPhaseStage": "recruitment"
        }
      }
    },
    {
      "id": "entry_259_APPLY_MOVEMENT_ACTIONS",
      "kind": "action",
      "playerColor": "light_green",
      "moment": {
        "round": 9,
        "phase": "war",
        "stage": "movement",
        "playerColor": "light_green"
      },
      "action": {
        "type": "APPLY_MOVEMENT_ACTIONS",
        "payload": {}
      }
    },
    {
      "id": "entry_260_SET_WAR_PHASE_STAGE",
      "kind": "action",
      "playerColor": "light_green",
      "moment": {
        "round": 9,
        "phase": "war",
        "stage": "movement",
        "playerColor": "light_green"
      },
      "action": {
        "type": "SET_WAR_PHASE_STAGE",
        "payload": {
          "stage": "shooting",
          "timestamp": 1700000000000,
          "round": 9,
          "currentPlayerId": "player_id_light_green",
          "phase": "war",
          "warPhaseStage": "movement"
        }
      }
    },
    {
      "id": "entry_261_APPLY_SHOOTING_ACTIONS",
      "kind": "action",
      "playerColor": "light_green",
      "moment": {
        "round": 9,
        "phase": "war",
        "stage": "shooting",
        "playerColor": "light_green"
      },
      "action": {
        "type": "APPLY_SHOOTING_ACTIONS",
        "payload": {}
      }
    },
    {
      "id": "entry_262_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "light_green",
      "moment": {
        "round": 9,
        "phase": "war",
        "stage": "shooting",
        "playerColor": "light_green"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 9,
          "currentPlayerId": "player_id_light_green",
          "phase": "war",
          "warPhaseStage": "shooting"
        }
      }
    },
    {
      "id": "entry_263_CAPTURE_CITIES",
      "kind": "action",
      "playerColor": "light_green",
      "moment": {
        "round": 9,
        "phase": "war",
        "stage": "shooting",
        "playerColor": "light_green"
      },
      "action": {
        "type": "CAPTURE_CITIES",
        "payload": {
          "round": 9,
          "phase": "war"
        }
      }
    },
    {
      "id": "entry_264_START_NEXT_PHASE",
      "kind": "action",
      "playerColor": "light_green",
      "moment": {
        "round": 9,
        "phase": "war",
        "stage": "shooting",
        "playerColor": "light_green"
      },
      "action": {
        "type": "START_NEXT_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "newPolicy": {
            "id": "ecoanarchism",
            "name": "Экоанархизм",
            "description": "Пустые ячейки не ограничивают перемещение\nПередача снабжения в любую ячейку поля",
            "implemented": true,
            "color": "#D68A5A"
          },
          "round": 9,
          "currentPlayerId": "player_id_light_green",
          "phase": "war",
          "warPhaseStage": "shooting"
        }
      }
    },
    {
      "id": "entry_265_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 10,
        "phase": "supply",
        "stage": null,
        "playerColor": "red"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "9,-8",
          "unitId": "u_red_5_-1_0",
          "unitHexKey": "-1,0",
          "isAutoSupply": true,
          "isNotUndoable": false
        }
      }
    },
    {
      "id": "entry_266_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 10,
        "phase": "supply",
        "stage": null,
        "playerColor": "red"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "10,-9",
          "unitId": "u_red_6_2_-3",
          "unitHexKey": "2,-3",
          "isAutoSupply": true,
          "isNotUndoable": false
        }
      }
    },
    {
      "id": "entry_267_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 10,
        "phase": "supply",
        "stage": null,
        "playerColor": "red"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "11,-8",
          "unitId": "u_red_7_4_-4",
          "unitHexKey": "5,-4",
          "isAutoSupply": true,
          "isNotUndoable": false
        }
      }
    },
    {
      "id": "entry_268_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 10,
        "phase": "supply",
        "stage": null,
        "playerColor": "red"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "10,-7",
          "unitId": "u_red_8_9_-7",
          "unitHexKey": "7,-6",
          "isAutoSupply": true,
          "isNotUndoable": false
        }
      }
    },
    {
      "id": "entry_269_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 10,
        "phase": "supply",
        "stage": null,
        "playerColor": "red"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 10,
          "currentPlayerId": "player_id_red",
          "phase": "supply",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_270_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "light_green",
      "moment": {
        "round": 10,
        "phase": "supply",
        "stage": null,
        "playerColor": "light_green"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "6,-4",
          "unitId": "u_light_green_10_7_-4",
          "unitHexKey": "7,-4",
          "isAutoSupply": true,
          "isNotUndoable": false
        }
      }
    },
    {
      "id": "entry_271_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "light_green",
      "moment": {
        "round": 10,
        "phase": "supply",
        "stage": null,
        "playerColor": "light_green"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "5,-3",
          "unitId": "u_light_green_9_6_-3",
          "unitHexKey": "6,-3",
          "isAutoSupply": true,
          "isNotUndoable": false
        }
      }
    },
    {
      "id": "entry_272_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "light_green",
      "moment": {
        "round": 10,
        "phase": "supply",
        "stage": null,
        "playerColor": "light_green"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "6,-2",
          "unitId": "u_light_green_9_6_-3",
          "unitHexKey": "6,-3",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_273_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "light_green",
      "moment": {
        "round": 10,
        "phase": "supply",
        "stage": null,
        "playerColor": "light_green"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 10,
          "currentPlayerId": "player_id_light_green",
          "phase": "supply",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_274_START_NEXT_PHASE",
      "kind": "action",
      "playerColor": "light_green",
      "moment": {
        "round": 10,
        "phase": "supply",
        "stage": null,
        "playerColor": "light_green"
      },
      "action": {
        "type": "START_NEXT_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "newPolicy": {
            "id": "fanaticism",
            "name": "Фанатизм",
            "description": "Увеличенный доход руин\nБонус к урону отрядов смежно с руинами\nОбмен очков на монеты",
            "implemented": true,
            "color": "#A9A9A9"
          },
          "round": 10,
          "currentPlayerId": "player_id_light_green",
          "phase": "supply",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_275_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 10,
        "phase": "construction",
        "stage": null,
        "playerColor": "red"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 10,
          "currentPlayerId": "player_id_red",
          "phase": "construction",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_276_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "light_green",
      "moment": {
        "round": 10,
        "phase": "construction",
        "stage": null,
        "playerColor": "light_green"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 10,
          "currentPlayerId": "player_id_light_green",
          "phase": "construction",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_277_START_NEXT_PHASE",
      "kind": "action",
      "playerColor": "light_green",
      "moment": {
        "round": 10,
        "phase": "construction",
        "stage": null,
        "playerColor": "light_green"
      },
      "action": {
        "type": "START_NEXT_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "newPolicy": {
            "id": "theocracy",
            "name": "Теократия",
            "description": "Увеличенный доход храмов\nБонус к урону отрядов в городе с храмом",
            "implemented": true,
            "color": "#A9A9A9"
          },
          "round": 10,
          "currentPlayerId": "player_id_light_green",
          "phase": "construction",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_278_APPLY_RECRUITMENT_ACTIONS",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 10,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "red"
      },
      "action": {
        "type": "APPLY_RECRUITMENT_ACTIONS",
        "payload": {}
      }
    },
    {
      "id": "entry_279_SET_WAR_PHASE_STAGE",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 10,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "red"
      },
      "action": {
        "type": "SET_WAR_PHASE_STAGE",
        "payload": {
          "stage": "movement",
          "timestamp": 1700000000000,
          "round": 10,
          "currentPlayerId": "player_id_red",
          "phase": "war",
          "warPhaseStage": "recruitment"
        }
      }
    },
    {
      "id": "entry_280_APPLY_MOVEMENT_ACTIONS",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 10,
        "phase": "war",
        "stage": "movement",
        "playerColor": "red"
      },
      "action": {
        "type": "APPLY_MOVEMENT_ACTIONS",
        "payload": {}
      }
    },
    {
      "id": "entry_281_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 10,
        "phase": "war",
        "stage": "movement",
        "playerColor": "red"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 10,
          "currentPlayerId": "player_id_red",
          "phase": "war",
          "warPhaseStage": "movement"
        }
      }
    },
    {
      "id": "entry_282_APPLY_RECRUITMENT_ACTIONS",
      "kind": "action",
      "playerColor": "light_green",
      "moment": {
        "round": 10,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "light_green"
      },
      "action": {
        "type": "APPLY_RECRUITMENT_ACTIONS",
        "payload": {}
      }
    },
    {
      "id": "entry_283_SET_WAR_PHASE_STAGE",
      "kind": "action",
      "playerColor": "light_green",
      "moment": {
        "round": 10,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "light_green"
      },
      "action": {
        "type": "SET_WAR_PHASE_STAGE",
        "payload": {
          "stage": "movement",
          "timestamp": 1700000000000,
          "round": 10,
          "currentPlayerId": "player_id_light_green",
          "phase": "war",
          "warPhaseStage": "recruitment"
        }
      }
    },
    {
      "id": "entry_284_APPLY_MOVEMENT_ACTIONS",
      "kind": "action",
      "playerColor": "light_green",
      "moment": {
        "round": 10,
        "phase": "war",
        "stage": "movement",
        "playerColor": "light_green"
      },
      "action": {
        "type": "APPLY_MOVEMENT_ACTIONS",
        "payload": {}
      }
    },
    {
      "id": "entry_285_SET_WAR_PHASE_STAGE",
      "kind": "action",
      "playerColor": "light_green",
      "moment": {
        "round": 10,
        "phase": "war",
        "stage": "movement",
        "playerColor": "light_green"
      },
      "action": {
        "type": "SET_WAR_PHASE_STAGE",
        "payload": {
          "stage": "shooting",
          "timestamp": 1700000000000,
          "round": 10,
          "currentPlayerId": "player_id_light_green",
          "phase": "war",
          "warPhaseStage": "movement"
        }
      }
    },
    {
      "id": "entry_286_APPLY_SHOOTING_ACTIONS",
      "kind": "action",
      "playerColor": "light_green",
      "moment": {
        "round": 10,
        "phase": "war",
        "stage": "shooting",
        "playerColor": "light_green"
      },
      "action": {
        "type": "APPLY_SHOOTING_ACTIONS",
        "payload": {}
      }
    },
    {
      "id": "entry_287_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "light_green",
      "moment": {
        "round": 10,
        "phase": "war",
        "stage": "shooting",
        "playerColor": "light_green"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 10,
          "currentPlayerId": "player_id_light_green",
          "phase": "war",
          "warPhaseStage": "shooting"
        }
      }
    },
    {
      "id": "entry_288_CAPTURE_CITIES",
      "kind": "action",
      "playerColor": "light_green",
      "moment": {
        "round": 10,
        "phase": "war",
        "stage": "shooting",
        "playerColor": "light_green"
      },
      "action": {
        "type": "CAPTURE_CITIES",
        "payload": {
          "round": 10,
          "phase": "war"
        }
      }
    },
    {
      "id": "entry_289_START_NEXT_PHASE",
      "kind": "action",
      "playerColor": "light_green",
      "moment": {
        "round": 10,
        "phase": "war",
        "stage": "shooting",
        "playerColor": "light_green"
      },
      "action": {
        "type": "START_NEXT_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "newPolicy": {
            "id": "servarianism",
            "name": "Серваризм",
            "description": "Увеличенный доход рудников,\nсмежных казармам и крупными отрядам",
            "implemented": true,
            "color": "#DEA806"
          },
          "round": 10,
          "currentPlayerId": "player_id_light_green",
          "phase": "war",
          "warPhaseStage": "shooting"
        }
      }
    },
    {
      "id": "e_290_replica",
      "moment": {
        "round": 11,
        "phase": "supply",
        "stage": null,
        "playerColor": "blue"
      },
      "kind": "replica",
      "replica": {
        "text": "Гхаа. Ты — тот, кто не ударил. Старая Кость платит. Платить нечем — плачу правдой. Слушай три раза, дважды не скажу.",
        "characterName": "Мор-Гхаа",
        "side": "right",
        "characterImage": "/img/campaigns/humans/m5_morghaa.png"
      }
    },
    {
      "id": "e_291_replica",
      "moment": {
        "round": 11,
        "phase": "supply",
        "stage": null,
        "playerColor": "blue"
      },
      "kind": "replica",
      "replica": {
        "text": "Раз: мы не шли к вам. Мы шли ОТ. Орда — не копьё, орда — брызги. Камень упал далеко на востоке — вы просто берег, куда доплеснуло.",
        "characterName": "Мор-Гхаа",
        "side": "right",
        "characterImage": "/img/campaigns/humans/m5_morghaa.png"
      }
    },
    {
      "id": "e_292_replica",
      "moment": {
        "round": 11,
        "phase": "supply",
        "stage": null,
        "playerColor": "blue"
      },
      "kind": "replica",
      "replica": {
        "text": "Два: там, где упал камень, — трава стала пеплом. Стада ушли в землю, вода стала тихой. И мёртвые… …мёртвые перестали лежать. Мы несём своих с собой, чтобы лежали среди своих. Там — не лежит НИКТО.",
        "characterName": "Мор-Гхаа",
        "side": "right",
        "characterImage": "/img/campaigns/humans/m5_morghaa.png"
      }
    },
    {
      "id": "e_293_replica",
      "moment": {
        "round": 11,
        "phase": "supply",
        "stage": null,
        "playerColor": "blue"
      },
      "kind": "replica",
      "replica": {
        "text": "Три: это не голод и не война, человек. Голод кончается, война устаёт. ЭТО — не устаёт. Мы бежали три зимы, и оно не отстало ни на шаг. Просто мы — быстрее вас. Пока — быстрее. Всё. Правда кончилась.",
        "characterName": "Мор-Гхаа",
        "side": "right",
        "characterImage": "/img/campaigns/humans/m5_morghaa.png"
      }
    },
    {
      "id": "e_294_replica",
      "moment": {
        "round": 11,
        "phase": "supply",
        "stage": null,
        "playerColor": "blue"
      },
      "kind": "replica",
      "replica": {
        "text": "Спроси его — ЧТО это. Кто уронил камень. Есть ли у этого имя.",
        "characterName": "Луций",
        "side": "left",
        "characterImage": "/img/campaigns/humans/m5_lucius_doubt.png"
      }
    },
    {
      "id": "e_295_replica",
      "moment": {
        "round": 11,
        "phase": "supply",
        "stage": null,
        "playerColor": "blue"
      },
      "kind": "replica",
      "replica": {
        "text": "Он говорит… имя есть. Но имя — это зов. Он говорит: «Я старый, но не настолько, чтобы звать».",
        "characterName": "Ильва",
        "side": "right",
        "characterImage": "/img/campaigns/humans/m5_ilva_translate.png"
      }
    },
    {
      "id": "entry_296_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 11,
        "phase": "supply",
        "stage": null,
        "playerColor": "red"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "9,-8",
          "unitId": "u_red_5_-1_0",
          "unitHexKey": "-1,0",
          "isAutoSupply": true,
          "isNotUndoable": false
        }
      }
    },
    {
      "id": "entry_297_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 11,
        "phase": "supply",
        "stage": null,
        "playerColor": "red"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "10,-9",
          "unitId": "u_red_6_2_-3",
          "unitHexKey": "2,-3",
          "isAutoSupply": true,
          "isNotUndoable": false
        }
      }
    },
    {
      "id": "entry_298_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 11,
        "phase": "supply",
        "stage": null,
        "playerColor": "red"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "11,-8",
          "unitId": "u_red_7_4_-4",
          "unitHexKey": "5,-4",
          "isAutoSupply": true,
          "isNotUndoable": false
        }
      }
    },
    {
      "id": "entry_299_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 11,
        "phase": "supply",
        "stage": null,
        "playerColor": "red"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "10,-7",
          "unitId": "u_red_8_9_-7",
          "unitHexKey": "7,-6",
          "isAutoSupply": true,
          "isNotUndoable": false
        }
      }
    },
    {
      "id": "entry_300_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 11,
        "phase": "supply",
        "stage": null,
        "playerColor": "red"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 11,
          "currentPlayerId": "player_id_red",
          "phase": "supply",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_301_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "light_green",
      "moment": {
        "round": 11,
        "phase": "supply",
        "stage": null,
        "playerColor": "light_green"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "6,-4",
          "unitId": "u_light_green_10_7_-4",
          "unitHexKey": "7,-4",
          "isAutoSupply": true,
          "isNotUndoable": false
        }
      }
    },
    {
      "id": "entry_302_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "light_green",
      "moment": {
        "round": 11,
        "phase": "supply",
        "stage": null,
        "playerColor": "light_green"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "5,-3",
          "unitId": "u_light_green_9_6_-3",
          "unitHexKey": "6,-3",
          "isAutoSupply": true,
          "isNotUndoable": false
        }
      }
    },
    {
      "id": "entry_303_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "light_green",
      "moment": {
        "round": 11,
        "phase": "supply",
        "stage": null,
        "playerColor": "light_green"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "6,-2",
          "unitId": "u_light_green_9_6_-3",
          "unitHexKey": "6,-3",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_304_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "light_green",
      "moment": {
        "round": 11,
        "phase": "supply",
        "stage": null,
        "playerColor": "light_green"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 11,
          "currentPlayerId": "player_id_light_green",
          "phase": "supply",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_305_START_NEXT_PHASE",
      "kind": "action",
      "playerColor": "light_green",
      "moment": {
        "round": 11,
        "phase": "supply",
        "stage": null,
        "playerColor": "light_green"
      },
      "action": {
        "type": "START_NEXT_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "newPolicy": {
            "id": "agrarianism",
            "name": "Аграризм",
            "description": "Скидка на Ферму и Склад\nОбмен снабжения на монеты",
            "implemented": true,
            "color": "#D68A5A"
          },
          "round": 11,
          "currentPlayerId": "player_id_light_green",
          "phase": "supply",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_306_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 11,
        "phase": "construction",
        "stage": null,
        "playerColor": "red"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 11,
          "currentPlayerId": "player_id_red",
          "phase": "construction",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_307_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "light_green",
      "moment": {
        "round": 11,
        "phase": "construction",
        "stage": null,
        "playerColor": "light_green"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 11,
          "currentPlayerId": "player_id_light_green",
          "phase": "construction",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_308_START_NEXT_PHASE",
      "kind": "action",
      "playerColor": "light_green",
      "moment": {
        "round": 11,
        "phase": "construction",
        "stage": null,
        "playerColor": "light_green"
      },
      "action": {
        "type": "START_NEXT_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "newPolicy": {
            "id": "servarianism",
            "name": "Серваризм",
            "description": "Увеличенный доход рудников,\nсмежных казармам и крупными отрядам",
            "implemented": true,
            "color": "#DEA806"
          },
          "round": 11,
          "currentPlayerId": "player_id_light_green",
          "phase": "construction",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "e_309_replica",
      "moment": {
        "round": 11,
        "phase": "war",
        "stage": "movement",
        "playerColor": "blue"
      },
      "kind": "replica",
      "replica": {
        "text": "Квинт. Посмотри. Скажи, что видишь.",
        "characterName": "Луций",
        "side": "left",
        "characterImage": "/img/campaigns/humans/m5_lucius_doubt.png"
      }
    },
    {
      "id": "e_310_replica",
      "moment": {
        "round": 11,
        "phase": "war",
        "stage": "movement",
        "playerColor": "blue"
      },
      "kind": "replica",
      "replica": {
        "text": "Ничего, легат. Ни костра, ни дымка, ни искры до самого края. Я воевал тридцать лет. Ночью земля ВСЕГДА где-то горит — это и есть война, мальчик, — огни. А тут… тут не война прошла. Тут ПОГАСИЛИ.",
        "characterName": "Барба",
        "side": "left",
        "characterImage": "/img/campaigns/humans/m5_barba_dark.png"
      }
    },
    {
      "id": "e_311_replica",
      "moment": {
        "round": 11,
        "phase": "war",
        "stage": "movement",
        "playerColor": "blue"
      },
      "kind": "replica",
      "replica": {
        "text": "Я всю дорогу молилась, чтобы старик врал… Господин. Если он не врёт — это идёт и сюда. Не орда. То, что ЗА ней.",
        "characterName": "Ильва",
        "side": "right",
        "characterImage": "/img/campaigns/humans/m5_ilva_grief.png"
      }
    },
    {
      "id": "e_312_replica",
      "moment": {
        "round": 11,
        "phase": "war",
        "stage": "movement",
        "playerColor": "blue"
      },
      "kind": "replica",
      "replica": {
        "text": "Значит, у Рима меньше времени, чем врагов. Идём домой. Квинт. Тогда, у стойбища… я не жалел их. Я платил. По счёту, который открыл не ты и не я.",
        "characterName": "Луций",
        "side": "left",
        "characterImage": "/img/campaigns/humans/m5_lucius_resolve.png"
      }
    },
    {
      "id": "e_313_replica",
      "moment": {
        "round": 11,
        "phase": "war",
        "stage": "movement",
        "playerColor": "blue"
      },
      "kind": "replica",
      "replica": {
        "text": "…Знаю, мальчик. В том и беда: я знаю. Просто мой счёт — старше. Дай ему полежать.",
        "characterName": "Барба",
        "side": "left",
        "characterImage": "/img/campaigns/humans/m5_barba_broken.png"
      }
    },
    {
      "id": "entry_314_APPLY_RECRUITMENT_ACTIONS",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 11,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "red"
      },
      "action": {
        "type": "APPLY_RECRUITMENT_ACTIONS",
        "payload": {}
      }
    },
    {
      "id": "entry_315_SET_WAR_PHASE_STAGE",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 11,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "red"
      },
      "action": {
        "type": "SET_WAR_PHASE_STAGE",
        "payload": {
          "stage": "movement",
          "timestamp": 1700000000000,
          "round": 11,
          "currentPlayerId": "player_id_red",
          "phase": "war",
          "warPhaseStage": "recruitment"
        }
      }
    },
    {
      "id": "entry_316_APPLY_MOVEMENT_ACTIONS",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 11,
        "phase": "war",
        "stage": "movement",
        "playerColor": "red"
      },
      "action": {
        "type": "APPLY_MOVEMENT_ACTIONS",
        "payload": {}
      }
    },
    {
      "id": "entry_317_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 11,
        "phase": "war",
        "stage": "movement",
        "playerColor": "red"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 11,
          "currentPlayerId": "player_id_red",
          "phase": "war",
          "warPhaseStage": "movement"
        }
      }
    },
    {
      "id": "entry_318_APPLY_RECRUITMENT_ACTIONS",
      "kind": "action",
      "playerColor": "light_green",
      "moment": {
        "round": 11,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "light_green"
      },
      "action": {
        "type": "APPLY_RECRUITMENT_ACTIONS",
        "payload": {}
      }
    },
    {
      "id": "entry_319_SET_WAR_PHASE_STAGE",
      "kind": "action",
      "playerColor": "light_green",
      "moment": {
        "round": 11,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "light_green"
      },
      "action": {
        "type": "SET_WAR_PHASE_STAGE",
        "payload": {
          "stage": "movement",
          "timestamp": 1700000000000,
          "round": 11,
          "currentPlayerId": "player_id_light_green",
          "phase": "war",
          "warPhaseStage": "recruitment"
        }
      }
    },
    {
      "id": "entry_320_APPLY_MOVEMENT_ACTIONS",
      "kind": "action",
      "playerColor": "light_green",
      "moment": {
        "round": 11,
        "phase": "war",
        "stage": "movement",
        "playerColor": "light_green"
      },
      "action": {
        "type": "APPLY_MOVEMENT_ACTIONS",
        "payload": {}
      }
    },
    {
      "id": "entry_321_SET_WAR_PHASE_STAGE",
      "kind": "action",
      "playerColor": "light_green",
      "moment": {
        "round": 11,
        "phase": "war",
        "stage": "movement",
        "playerColor": "light_green"
      },
      "action": {
        "type": "SET_WAR_PHASE_STAGE",
        "payload": {
          "stage": "shooting",
          "timestamp": 1700000000000,
          "round": 11,
          "currentPlayerId": "player_id_light_green",
          "phase": "war",
          "warPhaseStage": "movement"
        }
      }
    },
    {
      "id": "entry_322_APPLY_SHOOTING_ACTIONS",
      "kind": "action",
      "playerColor": "light_green",
      "moment": {
        "round": 11,
        "phase": "war",
        "stage": "shooting",
        "playerColor": "light_green"
      },
      "action": {
        "type": "APPLY_SHOOTING_ACTIONS",
        "payload": {}
      }
    },
    {
      "id": "entry_323_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "light_green",
      "moment": {
        "round": 11,
        "phase": "war",
        "stage": "shooting",
        "playerColor": "light_green"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 11,
          "currentPlayerId": "player_id_light_green",
          "phase": "war",
          "warPhaseStage": "shooting"
        }
      }
    },
    {
      "id": "entry_324_CAPTURE_CITIES",
      "kind": "action",
      "playerColor": "light_green",
      "moment": {
        "round": 11,
        "phase": "war",
        "stage": "shooting",
        "playerColor": "light_green"
      },
      "action": {
        "type": "CAPTURE_CITIES",
        "payload": {
          "round": 11,
          "phase": "war"
        }
      }
    },
    {
      "id": "entry_325_START_NEXT_PHASE",
      "kind": "action",
      "playerColor": "light_green",
      "moment": {
        "round": 11,
        "phase": "war",
        "stage": "shooting",
        "playerColor": "light_green"
      },
      "action": {
        "type": "START_NEXT_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "newPolicy": {
            "id": "totalitarianism",
            "name": "Тоталитаризм",
            "description": "Очки за военные строения\nСкидка на Лагерь и Арсенал\nНайм отрядов увеличенного размера",
            "implemented": true,
            "color": "#98172d"
          },
          "round": 11,
          "currentPlayerId": "player_id_light_green",
          "phase": "war",
          "warPhaseStage": "shooting"
        }
      }
    },
    {
      "id": "entry_326_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 12,
        "phase": "supply",
        "stage": null,
        "playerColor": "red"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "9,-8",
          "unitId": "u_red_5_-1_0",
          "unitHexKey": "-1,0",
          "isAutoSupply": true,
          "isNotUndoable": false
        }
      }
    },
    {
      "id": "entry_327_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 12,
        "phase": "supply",
        "stage": null,
        "playerColor": "red"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "10,-9",
          "unitId": "u_red_6_2_-3",
          "unitHexKey": "2,-3",
          "isAutoSupply": true,
          "isNotUndoable": false
        }
      }
    },
    {
      "id": "entry_328_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 12,
        "phase": "supply",
        "stage": null,
        "playerColor": "red"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "11,-8",
          "unitId": "u_red_7_4_-4",
          "unitHexKey": "5,-4",
          "isAutoSupply": true,
          "isNotUndoable": false
        }
      }
    },
    {
      "id": "entry_329_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 12,
        "phase": "supply",
        "stage": null,
        "playerColor": "red"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "10,-7",
          "unitId": "u_red_8_9_-7",
          "unitHexKey": "7,-6",
          "isAutoSupply": true,
          "isNotUndoable": false
        }
      }
    },
    {
      "id": "entry_330_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 12,
        "phase": "supply",
        "stage": null,
        "playerColor": "red"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 12,
          "currentPlayerId": "player_id_red",
          "phase": "supply",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_331_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "light_green",
      "moment": {
        "round": 12,
        "phase": "supply",
        "stage": null,
        "playerColor": "light_green"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "6,-4",
          "unitId": "u_light_green_10_7_-4",
          "unitHexKey": "7,-4",
          "isAutoSupply": true,
          "isNotUndoable": false
        }
      }
    },
    {
      "id": "entry_332_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "light_green",
      "moment": {
        "round": 12,
        "phase": "supply",
        "stage": null,
        "playerColor": "light_green"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "5,-3",
          "unitId": "u_light_green_9_6_-3",
          "unitHexKey": "6,-3",
          "isAutoSupply": true,
          "isNotUndoable": false
        }
      }
    },
    {
      "id": "entry_333_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "light_green",
      "moment": {
        "round": 12,
        "phase": "supply",
        "stage": null,
        "playerColor": "light_green"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "6,-2",
          "unitId": "u_light_green_9_6_-3",
          "unitHexKey": "6,-3",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_334_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "light_green",
      "moment": {
        "round": 12,
        "phase": "supply",
        "stage": null,
        "playerColor": "light_green"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 12,
          "currentPlayerId": "player_id_light_green",
          "phase": "supply",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_335_START_NEXT_PHASE",
      "kind": "action",
      "playerColor": "light_green",
      "moment": {
        "round": 12,
        "phase": "supply",
        "stage": null,
        "playerColor": "light_green"
      },
      "action": {
        "type": "START_NEXT_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "newPolicy": {
            "id": "barbarism",
            "name": "Варварство",
            "description": "Бесплатный наем Пехоты\nУвеличенный урон в ближнем бою\nОчки за урон",
            "implemented": true,
            "color": "#98172d"
          },
          "round": 12,
          "currentPlayerId": "player_id_light_green",
          "phase": "supply",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_336_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 12,
        "phase": "construction",
        "stage": null,
        "playerColor": "red"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 12,
          "currentPlayerId": "player_id_red",
          "phase": "construction",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_337_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "light_green",
      "moment": {
        "round": 12,
        "phase": "construction",
        "stage": null,
        "playerColor": "light_green"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 12,
          "currentPlayerId": "player_id_light_green",
          "phase": "construction",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_338_START_NEXT_PHASE",
      "kind": "action",
      "playerColor": "light_green",
      "moment": {
        "round": 12,
        "phase": "construction",
        "stage": null,
        "playerColor": "light_green"
      },
      "action": {
        "type": "START_NEXT_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "newPolicy": {
            "id": "fortificationism",
            "name": "Фортификационизм",
            "description": "Мгновенное строительство и скидка для крепостей\nБонус к урону рядом с крепостью",
            "implemented": true,
            "color": "#865333"
          },
          "round": 12,
          "currentPlayerId": "player_id_light_green",
          "phase": "construction",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_339_APPLY_RECRUITMENT_ACTIONS",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 12,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "red"
      },
      "action": {
        "type": "APPLY_RECRUITMENT_ACTIONS",
        "payload": {}
      }
    },
    {
      "id": "entry_340_SET_WAR_PHASE_STAGE",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 12,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "red"
      },
      "action": {
        "type": "SET_WAR_PHASE_STAGE",
        "payload": {
          "stage": "movement",
          "timestamp": 1700000000000,
          "round": 12,
          "currentPlayerId": "player_id_red",
          "phase": "war",
          "warPhaseStage": "recruitment"
        }
      }
    },
    {
      "id": "entry_341_APPLY_MOVEMENT_ACTIONS",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 12,
        "phase": "war",
        "stage": "movement",
        "playerColor": "red"
      },
      "action": {
        "type": "APPLY_MOVEMENT_ACTIONS",
        "payload": {}
      }
    },
    {
      "id": "entry_342_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 12,
        "phase": "war",
        "stage": "movement",
        "playerColor": "red"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 12,
          "currentPlayerId": "player_id_red",
          "phase": "war",
          "warPhaseStage": "movement"
        }
      }
    },
    {
      "id": "entry_343_APPLY_RECRUITMENT_ACTIONS",
      "kind": "action",
      "playerColor": "light_green",
      "moment": {
        "round": 12,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "light_green"
      },
      "action": {
        "type": "APPLY_RECRUITMENT_ACTIONS",
        "payload": {}
      }
    },
    {
      "id": "entry_344_SET_WAR_PHASE_STAGE",
      "kind": "action",
      "playerColor": "light_green",
      "moment": {
        "round": 12,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "light_green"
      },
      "action": {
        "type": "SET_WAR_PHASE_STAGE",
        "payload": {
          "stage": "movement",
          "timestamp": 1700000000000,
          "round": 12,
          "currentPlayerId": "player_id_light_green",
          "phase": "war",
          "warPhaseStage": "recruitment"
        }
      }
    },
    {
      "id": "entry_345_APPLY_MOVEMENT_ACTIONS",
      "kind": "action",
      "playerColor": "light_green",
      "moment": {
        "round": 12,
        "phase": "war",
        "stage": "movement",
        "playerColor": "light_green"
      },
      "action": {
        "type": "APPLY_MOVEMENT_ACTIONS",
        "payload": {}
      }
    },
    {
      "id": "entry_346_SET_WAR_PHASE_STAGE",
      "kind": "action",
      "playerColor": "light_green",
      "moment": {
        "round": 12,
        "phase": "war",
        "stage": "movement",
        "playerColor": "light_green"
      },
      "action": {
        "type": "SET_WAR_PHASE_STAGE",
        "payload": {
          "stage": "shooting",
          "timestamp": 1700000000000,
          "round": 12,
          "currentPlayerId": "player_id_light_green",
          "phase": "war",
          "warPhaseStage": "movement"
        }
      }
    },
    {
      "id": "entry_347_APPLY_SHOOTING_ACTIONS",
      "kind": "action",
      "playerColor": "light_green",
      "moment": {
        "round": 12,
        "phase": "war",
        "stage": "shooting",
        "playerColor": "light_green"
      },
      "action": {
        "type": "APPLY_SHOOTING_ACTIONS",
        "payload": {}
      }
    },
    {
      "id": "entry_348_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "light_green",
      "moment": {
        "round": 12,
        "phase": "war",
        "stage": "shooting",
        "playerColor": "light_green"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 12,
          "currentPlayerId": "player_id_light_green",
          "phase": "war",
          "warPhaseStage": "shooting"
        }
      }
    },
    {
      "id": "entry_349_CAPTURE_CITIES",
      "kind": "action",
      "playerColor": "light_green",
      "moment": {
        "round": 12,
        "phase": "war",
        "stage": "shooting",
        "playerColor": "light_green"
      },
      "action": {
        "type": "CAPTURE_CITIES",
        "payload": {
          "round": 12,
          "phase": "war"
        }
      }
    },
    {
      "id": "entry_350_START_NEXT_PHASE",
      "kind": "action",
      "playerColor": "light_green",
      "moment": {
        "round": 12,
        "phase": "war",
        "stage": "shooting",
        "playerColor": "light_green"
      },
      "action": {
        "type": "START_NEXT_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "newPolicy": {
            "id": "ecoanarchism",
            "name": "Экоанархизм",
            "description": "Пустые ячейки не ограничивают перемещение\nПередача снабжения в любую ячейку поля",
            "implemented": true,
            "color": "#D68A5A"
          },
          "round": 12,
          "currentPlayerId": "player_id_light_green",
          "phase": "war",
          "warPhaseStage": "shooting"
        }
      }
    }
  ],
  "objectives": [
    {
      "id": "h5_break_blackteeth",
      "type": "destroy_all_enemy_units",
      "params": {
        "color": "red"
      },
      "text": "Пробей заслоны Чёрного Зуба и добей ватагу",
      "isMain": true,
      "isFailure": false
    },
    {
      "id": "h5_saddle",
      "type": "unit_reaches_hex",
      "params": {
        "hexKey": "8,-6"
      },
      "text": "Выведи отряд на седловину и удерживай её (кормить её будет ферма передового лагеря — но только когда тропа очищена от ватаги; или захваченные фермы гнезда)",
      "isMain": true,
      "isFailure": false
    },
    {
      "id": "h5_shaman",
      "type": "survive_rounds",
      "params": {
        "rounds": 12
      },
      "text": "Дослушай Старую Кость — продержись до 12-го раунда",
      "isMain": true,
      "isFailure": false
    },
    {
      "id": "h5_ruins_watch",
      "type": "unit_reaches_hex",
      "params": {
        "hexKey": "-3,2"
      },
      "text": "Займи руины Норика дозором",
      "isMain": false,
      "isFailure": false
    },
    {
      "id": "h5_forward_camp",
      "type": "build_central_quarter",
      "params": {
        "hexKey": "1,-1"
      },
      "text": "Заложи передовой лагерь у второго мёртвого городка — выше руин корпус не прокормить",
      "isMain": false,
      "isFailure": false
    },
    {
      "id": "h5_keep_corps",
      "type": "units_count",
      "params": {
        "amount": 4
      },
      "text": "Сбереги корпус — обоз отстал, хлеб дают только фермы",
      "isMain": false,
      "isFailure": false
    },
    {
      "id": "h5_corps_lost",
      "type": "lose_all_units",
      "params": {},
      "text": "Корпус не должен погибнуть",
      "isMain": false,
      "isFailure": true
    }
  ]
};

export default mission;
